const mgmt = {
  // Navigation
  'nav.dashboard': '仪表板',
  'nav.projects': '项目',
  'nav.instructions': '指令',
  'nav.dailyLog': '日志',
  'nav.alerts': '提醒',
  'nav.newProject': '新建项目',
  'nav.management': '管理',
  'nav.logout': '退出登录',
  'nav.menu': '菜单',
  'nav.actions': '操作',

  // Language switcher
  'lang.en': 'EN',
  'lang.ja': 'JP',
  'lang.zh': '中文',
  'lang.label': '语言',

  // Dashboard
  'dashboard.title': '仪表板',
  'dashboard.subtitle': '项目控制面板',
  'dashboard.projectControl': '项目管理',
  'dashboard.activeProjects': '进行中',
  'dashboard.completed': '已完成',
  'dashboard.onHold': '暂停',
  'dashboard.planning': '规划中',
  'dashboard.allProjects': '所有项目',
  'dashboard.inProgressNow': '当前进行中',
  'dashboard.fullyFinished': '全部完成',
  'dashboard.blockedProjects': '暂停项目',
  'dashboard.notYetStarted': '尚未开始',
  'dashboard.viewAll': '查看全部',
  'dashboard.manage': '管理',
  'dashboard.noProjects': '暂无项目',
  'dashboard.createFirst': '创建您的第一个项目以开始使用',
  'dashboard.createFirstProject': '创建第一个项目',
  'dashboard.noActiveProjects': '没有进行中的项目',
  'dashboard.createProject': '创建项目',
  'dashboard.moreProjects': '+{count} 个项目',

  // Project statuses
  'status.active': '进行中',
  'status.planning': '规划中',
  'status.onHold': '暂停',
  'status.complete': '完成',
  'status.completed': '已完成',
  'status.closed': '已关闭',
  'status.draft': '草稿',
  'status.sent': '已发送',
  'status.pending': '待处理',
  'status.approved': '已批准',
  'status.rejected': '已拒绝',
  'status.inProgress': '进行中',
  'status.notStarted': '未开始',
  'status.delayed': '延迟',

  // Projects page
  'projects.title': '项目',
  'projects.search': '搜索项目、客户、地址...',
  'projects.noAddress': '未设置地址',
  'projects.noClient': '未设置客户',
  'projects.noAddressShort': '无地址',
  'projects.noProjectsFound': '未找到项目',
  'projects.tryAdjusting': '请调整搜索条件或筛选器',
  'projects.noMatchFilter': '没有符合此筛选条件的项目',
  'projects.clearSearch': '清除搜索',
  'projects.loadingProjects': '正在加载项目...',
  'projects.project': '个项目',
  'projects.projects': '个项目',
  'projects.matching': '匹配',
  'projects.schedFinal': '进度',
  'projects.clFinal': '清单',

  // Project detail tabs
  'tabs.overview': '概览',
  'tabs.stages': '阶段',
  'tabs.schedule': '进度计划',
  'tabs.checklist': '检查清单',
  'tabs.photos': '照片',
  'tabs.files': '文件',
  'tabs.tasks': '任务',
  'tabs.notifications': '通知',
  'tabs.questions': '问题',
  'tabs.dailyLog': '日志',
  'tabs.instructions': '指令',
  'tabs.payments': '付款',
  'tabs.more': '更多',

  // Project detail overview
  'overview.projectDetails': '项目详情',
  'overview.client': '客户',
  'overview.type': '类型',
  'overview.startDate': '开始日期',
  'overview.estCompletion': '预计完成',
  'overview.status': '状态',
  'overview.currentStage': '当前阶段',
  'overview.projectProgress': '项目进度',
  'overview.scheduleFinal': '进度最终',
  'overview.checklistFinal': '清单最终',
  'overview.pendingScheduleItems': '待处理进度项',
  'overview.description': '描述',
  'overview.files': '文件',
  'overview.schedule': '进度计划',
  'overview.recalculateProgress': '重新计算项目进度',
  'overview.editProject': '编辑项目',
  'overview.projectSettings': '项目设置',

  // Progress / stats
  'progress.projectProgress': '项目进度',
  'progress.management': '管理',
  'progress.subcontractor': '分包商',
  'progress.stage': '阶段',
  'progress.loading': '加载中...',
  'progress.done': '完成',
  'progress.pending': '待处理',
  'progress.waitingForSub': '等待分包商确认',
  'progress.scheduleHealth': '进度健康状况',
  'progress.reviewPendingSchedule': '查看待处理进度',
  'progress.pendingScheduleItems': '{count} 个进度项待处理',
  'progress.checklistItemsPending': '{count} 个清单项待处理',
  'progress.scheduleFormula': '进度最终 {sched}% × 50% + 清单最终 {cl}% × 50% = {total}% 项目进度',
  'progress.mgmtChecksComplete': '管理检查完成。等待分包商确认。',
  'progress.subPendingDesc': '{remaining} / {total} 个分包商必填清单项仍待确认。',
  'progress.viewPendingItems': '查看待处理项',

  // Notifications
  'notifications.title': '通知',
  'notifications.allNotifications': '所有通知',
  'notifications.projectNotifications': '项目通知',
  'notifications.markAllRead': '全部标为已读',
  'notifications.noNotifications': '暂无通知',
  'notifications.allCaughtUp': '您已查看所有通知',
  'notifications.loading': '正在加载通知...',
  'notifications.justNow': '刚刚',
  'notifications.minAgo': '{n} 分钟前',
  'notifications.hrAgo': '{n} 小时前',
  'notifications.hrsAgo': '{n} 小时前',
  'notifications.dayAgo': '{n} 天前',
  'notifications.daysAgo': '{n} 天前',

  // Questions
  'questions.clientQuestions': '客户问题',
  'questions.unanswered': '未回答',
  'questions.noQuestions': '暂无问题',
  'questions.clientQuestionsAppear': '客户问题将显示在这里',
  'questions.managementReply': '管理回复',
  'questions.typeReply': '输入回复...',
  'questions.sendReply': '发送回复',

  // Instructions
  'instructions.title': '指令',
  'instructions.subtitle': '管理和跟踪发送给分包商的指令',
  'instructions.newInstruction': '新建指令',
  'instructions.changeOrder': '变更单',
  'instructions.reload': '刷新',
  'instructions.total': '总计',
  'instructions.open': '未完成',
  'instructions.changeOrders': '变更单',
  'instructions.completed': '已完成',
  'instructions.closed': '已关闭',
  'instructions.allProjects': '所有项目',
  'instructions.allPriorities': '所有优先级',
  'instructions.allStatuses': '全部',
  'instructions.sent': '已发送',
  'instructions.inProgress': '进行中',
  'instructions.noInstructions': '未找到指令',
  'instructions.createInstruction': '创建指令以发送给分包商',
  'instructions.createChangeOrder': '创建变更单',
  'instructions.createFirstInstruction': '创建第一条指令',
  'instructions.to': '收件人',
  'instructions.due': '截止',
  'instructions.highPriority': '高优先级',
  'instructions.responseRequired': '需要回复',
  'instructions.readMore': '阅读更多',
  'instructions.showLess': '收起',
  'instructions.managementNote': '管理备注',
  'instructions.markCompleted': '标为完成',
  'instructions.markClosed': '标为关闭',
  'instructions.viewInProject': '在项目中查看',
  'instructions.unassigned': '未分配',
  'instructions.items': '条',
  'instructions.instruction': '指令',
  'instructions.internalDraft': '内部 / 草稿',
  'instructions.subcontractor': '分包商',
  'instructions.clientLabel': '客户',
  'instructions.reasonForChange': '变更原因',
  'instructions.currentFinish': '当前完成时间',
  'instructions.newFinish': '新完成时间',
  'instructions.costImpact': '费用影响',
  'instructions.scheduleImpact': '进度影响',
  'instructions.requiresClientApproval': '需要客户批准',
  'instructions.clientApproved': '客户已批准',
  'instructions.clientRejected': '客户已拒绝',

  // Daily Log
  'dailyLog.title': '日志审核',
  'dailyLog.createDailyLog': '创建日志',
  'dailyLog.internalOnly': '仅内部',
  'dailyLog.shareWithClient': '与客户共享',
  'dailyLog.publishedToClient': '已发布给客户',
  'dailyLog.selectPhotos': '选择照片',
  'dailyLog.managementComment': '管理评论',
  'dailyLog.internalNote': '内部备注',
  'dailyLog.pendingReview': '待审核',
  'dailyLog.approvedForClient': '已批准给客户',
  'dailyLog.internalOnlyBadge': '仅内部',
  'dailyLog.rejected': '已拒绝',
  'dailyLog.allStatuses': '所有状态',
  'dailyLog.allProjects': '所有项目',
  'dailyLog.allStages': '所有阶段',
  'dailyLog.allSubcontractors': '所有分包商',
  'dailyLog.filters': '筛选器',
  'dailyLog.showAll': '显示全部',
  'dailyLog.hide': '隐藏',
  'dailyLog.pending': '待处理',
  'dailyLog.approve': '批准',
  'dailyLog.internal': '内部',
  'dailyLog.reject': '拒绝',
  'dailyLog.instruction': '指令',
  'dailyLog.noPhotosMatch': '没有符合筛选条件的照片',
  'dailyLog.tryAdjusting': '请调整筛选条件',
  'dailyLog.noPhotosYet': '尚未上传日志照片',
  'dailyLog.selected': '已选择',
  'dailyLog.approveForClient': '批准给客户',
  'dailyLog.keepInternal': '保持内部',
  'dailyLog.clearSelection': '清除选择',
  'dailyLog.apply': '应用',
  'dailyLog.applying': '应用中...',
  'dailyLog.cancel': '取消',
  'dailyLog.optionalNote': '可选备注...',
  'dailyLog.removePhoto': '删除此照片？',
  'dailyLog.removePhotoDesc': '照片将被标记为已删除。此操作无法撤销。',
  'dailyLog.remove': '删除',
  'dailyLog.managementNoteLabel': '管理备注',
  'dailyLog.addNote': '添加关于此照片的备注...',
  'dailyLog.saveNote': '保存备注',
  'dailyLog.clientVisible': '客户可见',
  'dailyLog.selectAll': '全选',
  'dailyLog.deselectAll': '取消全选',
  'dailyLog.titleRequired': '标题 *',
  'dailyLog.titlePlaceholder': '例：基础工程进度 — 5月11日',
  'dailyLog.visibility': '可见性',
  'dailyLog.photosSelected': '{count} 张照片将包含在此日志中。',
  'dailyLog.creating': '创建中...',
  'dailyLog.retry': '重试',
  'dailyLog.reset': '重置',

  // Photos tab
  'photos.title': '照片库',
  'photos.upload': '上传',
  'photos.noPhotos': '暂无照片',
  'photos.uploadToDocument': '上传照片以记录此项目',
  'photos.loadingPhotos': '正在加载照片...',
  'photos.deletePhoto': '删除此照片？',
  'photos.cannotBeUndone': '此操作无法撤销。',
  'photos.deleting': '删除中...',
  'photos.delete': '删除',
  'photos.cancel': '取消',
  'photos.uploadPhotos': '上传照片',
  'photos.openPreview': '打开预览',

  // Files tab
  'files.title': '项目文件',
  'files.upload': '上传',
  'files.folder': '文件夹',
  'files.recentFiles': '最近文件',
  'files.allFiles': '所有文件',
  'files.total': '总计',
  'files.all': '全部',
  'files.visible': '可见',
  'files.hidden': '隐藏',
  'files.noFiles': '暂无文件',
  'files.uploadToGetStarted': '上传文件以开始使用',
  'files.uploadToFolder': '上传文件到此文件夹',
  'files.newFolder': '新建文件夹',
  'files.folderName': '文件夹名称',
  'files.folderNamePlaceholder': '例：图纸、发票、合同...',
  'files.createFolder': '创建文件夹',
  'files.loadingFiles': '正在加载文件...',
  'files.openFile': '打开文件',
  'files.deleteFile': '删除文件',
  'files.hideFile': '隐藏',
  'files.showFile': '显示',
  'files.uploadFiles': '上传文件',

  // Schedule tab
  'schedule.title': '进度计划',
  'schedule.scheduleFinal': '进度最终',
  'schedule.checklistFinal': '清单最终',
  'schedule.projectProgress': '项目进度',
  'schedule.pendingItems': '待处理项',
  'schedule.complete': '完成',
  'schedule.completed': '已完成',
  'schedule.notMapped': '未映射',
  'schedule.noChecklistMapped': '未映射清单',
  'schedule.manualComplete': '手动完成',
  'schedule.criticalItems': '关键项',
  'schedule.delayedItems': '延迟项',
  'schedule.atRiskItems': '风险项',
  'schedule.scheduleHealth': '进度健康状况',
  'schedule.reviewPendingSchedule': '查看待处理进度',
  'schedule.markAllPendingComplete': '将所有待处理项标为完成',
  'schedule.recalculateProgress': '重新计算项目进度',
  'schedule.noScheduleYet': '尚未创建进度计划',
  'schedule.createFromTemplate': '从开发模板创建进度计划',
  'schedule.scheduleItemsNeedDates': '进度项需要日期',
  'schedule.generateInitialTimeline': '生成初始时间线',
  'schedule.noItemsMatchFilter': '没有符合当前筛选条件的进度项。',
  'schedule.clearFilters': '清除筛选器',
  'schedule.retry': '重试',
  'schedule.refreshing': '正在刷新进度数据...',
  'schedule.markAllConfirmTitle': '将所有待处理项标为完成？',
  'schedule.markAllConfirmDesc': '将 {count} 个进度项标为最终进度100%完成。',
  'schedule.markAllWarning': '此操作不易撤销。',
  'schedule.marking': '标记中...',
  'schedule.markComplete': '将 {count} 项标为完成',
  'schedule.cancel': '取消',
  'schedule.recalcCriticalPath': '重新计算关键路径？',
  'schedule.recalcDesc': '将从当前进度项和链接计算关键路径。',
  'schedule.recalcWarning': '重新计算后将启用关键路径提醒。',
  'schedule.calculating': '计算中...',
  'schedule.recalcAndSave': '重新计算并保存',
  'schedule.setupInProgress': '进度计划已导入。设置进行中。',
  'schedule.setupDesc': '在依赖关键路径提醒之前，请完成清单映射和进度跟踪。',
  'schedule.pendingCount': '{count} 项待处理',
  'schedule.scheduleComplete': '进度完成',
  'schedule.showDetails': '显示详情',
  'schedule.hideDetails': '隐藏详情',
  'schedule.reviewPendingItems': '查看待处理项',
  'schedule.noChecklistMapping': '无清单映射',
  'schedule.incompleteChecklist': '清单未完成',
  'schedule.calculatedFrom': '由清单50% + 进度50%计算得出',

  // Checklist tab
  'checklist.title': '检查清单',
  'checklist.managementCheck': '管理检查',
  'checklist.subcontractorCheck': '分包商检查',
  'checklist.finalApproval': '最终批准',
  'checklist.required': '必填',
  'checklist.checked': '已检查',
  'checklist.unchecked': '未检查',
  'checklist.fullyApproved': '完全批准',
  'checklist.waitManagement': '等待管理',
  'checklist.waitSubcontractor': '等待分包商',
  'checklist.unmapped': '未映射',
  'checklist.allStages': '所有阶段',
  'checklist.allScheduleItems': '所有进度项',
  'checklist.byStage': '按阶段',
  'checklist.bySection': '按章节',
  'checklist.noChecklistItems': '暂无清单项',
  'checklist.createChecklist': '创建清单',
  'checklist.createChecklistDesc': '创建清单以跟踪项目里程碑、检查和签字确认。',
  'checklist.loadingChecklist': '正在加载清单...',
  'checklist.failedToLoad': '清单加载失败',
  'checklist.retry': '重试',
  'checklist.unmappedItems': '未映射的清单项',
  'checklist.unmappedDesc': '这些项目未链接到任何进度项。请映射以整理您的清单。',
  'checklist.map': '映射',
  'checklist.cancel': '取消',
  'checklist.selectSchedule': '选择进度项...',
  'checklist.allChecked': '所有清单项已检查。干得好！',
  'checklist.viewChecked': '查看已检查项',
  'checklist.noItemsMatch': '没有符合当前筛选条件的清单项。',
  'checklist.showAll': '显示所有项',
  'checklist.mgmtDone': '管理完成',
  'checklist.completeMgmt': '完成管理检查',
  'checklist.subDone': '分包商完成',
  'checklist.completeSub': '完成分包商检查',
  'checklist.finalComplete': '最终：完成',
  'checklist.waitingForSub': '等待分包商',
  'checklist.waitingForMgmt': '等待管理',
  'checklist.requestAction': '请求操作',
  'checklist.refreshing': '正在刷新清单数据...',
  'checklist.noMappedItems': '没有映射到 {stage} 的清单项',
  'checklist.noMappedDesc': '此阶段尚无链接的清单项。',
  'checklist.unmappedCount': '{count} 个未映射项',
  'checklist.progress': '{stage} 进度',
  'checklist.managementDone': '管理：完成',
  'checklist.managementPending': '管理：待处理',
  'checklist.subcontractorDone': '分包商：完成',
  'checklist.subcontractorPending': '分包商：待处理',

  // Stages tab
  'stages.title': '阶段',
  'stages.noScheduleItems': '暂无进度项',
  'stages.createScheduleFirst': '从进度计划标签创建进度计划，以查看与清单项链接的阶段。',
  'stages.failedToLoad': '阶段加载失败',
  'stages.retry': '重试',
  'stages.suggestedStage': '建议当前阶段',
  'stages.updateProjectStage': '更新项目阶段',
  'stages.updateStageTitle': '更新项目阶段',
  'stages.updateStageConfirm': '确定要将此项目移至 {stage} 吗？',
  'stages.updateStageDesc': '这将根据进度完成情况更新项目的当前阶段。',
  'stages.cancel': '取消',
  'stages.current': '当前',
  'stages.scheduleComplete': '进度完成',
  'stages.schedule': '进度',
  'stages.checklistFinal': '清单最终',
  'stages.noChecklistMapped': '无清单映射 — 仅进度',
  'stages.combinedProgress': '阶段进度（综合）',
  'stages.checklistFinalApproval': '清单最终批准',
  'stages.paymentMilestones': '付款里程碑',
  'stages.backToAll': '返回所有施工项',
  'stages.oneOrMoreDelayed': '一个或多个项目延迟',
  'stages.notMapped': '未映射到清单 — 计为完成',
  'stages.checklistComplete': '清单完成',
  'stages.checklistIncomplete': '清单未完成',
  'stages.manuallyCompleted': '手动完成',
  'stages.manual': '手动 {pct}% — 无清单',

  // Tasks tab
  'tasks.title': '任务',
  'tasks.open': '未完成',
  'tasks.overdue': '已逾期',
  'tasks.total': '总计',
  'tasks.all': '全部',
  'tasks.decision': '决策',
  'tasks.payment': '付款',
  'tasks.completed': '已完成',
  'tasks.newTask': '新建',
  'tasks.noTasks': '暂无任务',
  'tasks.createTask': '创建任务以开始使用',
  'tasks.noTasksAssigned': '尚未分配任务',
  'tasks.loadingTasks': '正在加载任务...',
  'tasks.taskType': '任务类型',
  'tasks.assignTo': '分配给',
  'tasks.dueDate': '截止日期',
  'tasks.description': '描述',
  'tasks.options': '选项',
  'tasks.invoiceNo': '发票号',
  'tasks.amount': '金额（$）',
  'tasks.paymentDueDate': '付款截止日期',
  'tasks.creating': '创建中...',
  'tasks.createTask2': '创建任务',
  'tasks.title2': '标题 *',
  'tasks.titlePlaceholder': '例：需要选择瓷砖',
  'tasks.descPlaceholder': '描述需要完成的工作...',
  'tasks.addOption': '+ 添加选项',
  'tasks.optionLabel': '选项标签',
  'tasks.optionDesc': '描述（可选）',
  'tasks.priceNote': '价格备注（可选）',
  'tasks.invoicePlaceholder': '例：PC-003',
  'tasks.amountPlaceholder': '例：35000',
  'tasks.selectThisOption': '选择此选项',
  'tasks.selectionConfirmed': '选择已确认',
  'tasks.respond': '回复',
  'tasks.typeResponse': '输入回复...',
  'tasks.submitResponse': '提交回复',
  'tasks.markAsPaid': '标为已付款',
  'tasks.paymentRef': '付款参考 / 交易ID',
  'tasks.paymentNote': '备注（可选）',
  'tasks.confirmPayment': '确认收到付款',
  'tasks.close': '关闭',
  'tasks.due': '截止',
  'tasks.options2': '选项',
  'tasks.selected': '已选择',
  'tasks.invoiceDetails': '发票详情',
  'tasks.paymentStatus': '付款状态',
  'tasks.reference': '参考',
  'tasks.response': '回复',

  // New Project wizard
  'newProject.title': '新建项目',
  'newProject.projectInfo': '项目信息',
  'newProject.basicDetails': '项目基本信息',
  'newProject.projectName': '项目名称',
  'newProject.projectNamePlaceholder': '例：亨德森翻新',
  'newProject.siteAddress': '施工地址',
  'newProject.siteAddressPlaceholder': '例：42 Bethells Rd, Henderson, Auckland',
  'newProject.clientName': '客户名称',
  'newProject.clientNamePlaceholder': '例：山本家族',
  'newProject.projectDescription': '项目描述',
  'newProject.descPlaceholder': '项目范围的简要描述...',
  'newProject.projectType': '项目类型',
  'newProject.selectType': '选择建设项目类型',
  'newProject.scheduleSetup': '进度设置',
  'newProject.coverPhoto': '封面照片',
  'newProject.teamAccess': '团队访问',
  'newProject.stages': '施工阶段',
  'newProject.overallSchedule': '整体进度',
  'newProject.paymentSchedule': '付款计划',
  'newProject.reviewCreate': '确认并创建',
  'newProject.continue': '继续',
  'newProject.back': '返回',
  'newProject.createProject': '创建项目',
  'newProject.creatingProject': '正在创建项目...',
  'newProject.viewProject': '查看项目',
  'newProject.projectCreated': '项目创建成功！',
  'newProject.startDate': '项目开始日期',
  'newProject.estCompletion': '预计完成日期',
  'newProject.subcontractor': '分包商',
  'newProject.client': '客户',
  'newProject.optional': '（可选）',
  'newProject.emailAddress': '电子邮件',
  'newProject.contactName': '联系人姓名',
  'newProject.company': '公司',
  'newProject.fullName': '全名',
  'newProject.selectStages': '选择适用于此项目的阶段',
  'newProject.stagesSelected': '已选择 {count} 个阶段',
  'newProject.reviewDetails': '创建前请确认所有详情',
  'newProject.projectDetails': '项目详情',
  'newProject.scheduleSetupLabel': '进度设置',
  'newProject.stagesLabel': '阶段',
  'newProject.teamLabel': '团队',
  'newProject.paymentScheduleLabel': '付款计划',
  'newProject.noPaymentSchedule': '无付款计划 — 可在编辑项目中稍后添加',
  'newProject.readyToCreate': '准备创建此项目？',
  'newProject.uniqueCode': '将自动生成唯一项目代码。',

  // Edit Project
  'editProject.title': '编辑项目',
  'editProject.basicInfo': '基本信息',
  'editProject.typeCover': '类型和封面',
  'editProject.stages': '阶段',
  'editProject.schedule': '进度',
  'editProject.payments': '付款',
  'editProject.saveChanges': '保存更改',
  'editProject.savingChanges': '正在保存更改...',
  'editProject.changesSaved': '更改已成功保存',
  'editProject.projectName': '项目名称',
  'editProject.siteAddress': '施工地址',
  'editProject.clientName': '客户名称',
  'editProject.projectDescription': '项目描述',
  'editProject.projectType': '项目类型',
  'editProject.coverPhoto': '封面照片',
  'editProject.constructionStages': '施工阶段',
  'editProject.addNewStage': '添加新阶段',
  'editProject.stageName': '阶段名称...',
  'editProject.add': '添加',
  'editProject.completion': '完成率',
  'editProject.planned': '计划',
  'editProject.actual': '实际',
  'editProject.start': '开始',
  'editProject.end': '结束',
  'editProject.delayReason': '延迟原因',
  'editProject.delayReasonPlaceholder': '描述延迟原因...',
  'editProject.overallSchedule': '整体进度',
  'editProject.startDate': '项目开始日期',
  'editProject.estCompletion': '预计完成日期',
  'editProject.resetToDefault': '重置为默认封面',
  'editProject.coverUrlPlaceholder': 'https://...（留空使用默认）',

  // Common buttons
  'btn.save': '保存',
  'btn.cancel': '取消',
  'btn.delete': '删除',
  'btn.edit': '编辑',
  'btn.upload': '上传',
  'btn.download': '下载',
  'btn.submit': '提交',
  'btn.send': '发送',
  'btn.continue': '继续',
  'btn.back': '返回',
  'btn.close': '关闭',
  'btn.reload': '刷新',
  'btn.review': '查看',
  'btn.filter': '筛选',
  'btn.search': '搜索',
  'btn.reset': '重置',
  'btn.confirm': '确认',
  'btn.markComplete': '标为完成',
  'btn.markResolved': '标为已解决',
  'btn.markClosed': '标为关闭',
  'btn.newProject': '新建项目',
  'btn.newInstruction': '新建指令',
  'btn.changeOrder': '变更单',
  'btn.sendInstruction': '发送指令',
  'btn.saveDraft': '保存草稿',
  'btn.assignSubcontractor': '分配分包商',
  'btn.tryAgain': '重试',
  'btn.retry': '重试',
  'btn.new': '新建',
  'btn.apply': '应用',
  'btn.dismiss': '关闭',
  'btn.updateStage': '更新项目阶段',

  // Forms
  'form.projectName': '项目名称',
  'form.address': '地址',
  'form.client': '客户',
  'form.type': '类型',
  'form.startDate': '开始日期',
  'form.estCompletion': '预计完成',
  'form.status': '状态',
  'form.priority': '优先级',
  'form.dueDate': '截止日期',
  'form.title': '标题',
  'form.message': '消息',
  'form.description': '描述',
  'form.attachment': '附件',
  'form.uploadFile': '上传文件',
  'form.uploadPhoto': '上传照片',
  'form.selectProject': '选择项目',
  'form.selectSubcontractor': '选择分包商',
  'form.selectClient': '选择客户',
  'form.required': '*',

  // Errors / empty states
  'error.noDataFound': '未找到数据',
  'error.noProjectsFound': '未找到项目',
  'error.noInstructionsYet': '暂无指令',
  'error.noSubcontractorsAssigned': '未分配分包商',
  'error.couldNotLoadData': '无法加载数据',
  'error.uploadFailed': '上传失败',
  'error.saveFailed': '保存失败',
  'error.pleaseTryAgain': '请重试',
  'error.areYouSure': '确定吗？',
  'error.cannotBeUndone': '此操作无法撤销',
  'error.projectNotFound': '未找到项目',
  'error.backToProjects': '返回项目列表',
  'error.failedToLoad': '加载失败',

  // Logout
  'logout.signOut': '退出登录？',
  'logout.signOutDesc': '您将退出 JPH Portal。',
  'logout.cancel': '取消',
  'logout.signOutBtn': '退出登录',

  // User menu
  'user.management': '管理',
  'user.jphPortal': 'JPH Portal',
  'user.producedBy': 'Japan Homes Group 出品',

  // Change password
  'password.changeTitle': '修改密码',
  'password.current': '当前密码',
  'password.new': '新密码',
  'password.confirmNew': '确认新密码',
  'password.cancel': '取消',
  'password.save': '更新密码',
  'password.changeSuccess': '密码已成功更新',
  'password.changeSuccessHint': '您的密码已更改。您可以继续使用门户；如在其它设备上被要求重新登录，请使用新密码登录。',
  'password.signInAgain': '重新登录',
  'password.continue': '继续',
  'nav.changePassword': '修改密码',

  // Status labels (for DB values → display)
  'statusLabel.active': '进行中',
  'statusLabel.planning': '规划中',
  'statusLabel.on_hold': '暂停',
  'statusLabel.complete': '完成',
  'statusLabel.completed': '完成',
  'statusLabel.closed': '已关闭',
  'statusLabel.draft': '草稿',
  'statusLabel.sent': '已发送',
  'statusLabel.seen': '已读',
  'statusLabel.in_progress': '进行中',
  'statusLabel.replied': '已回复',
  'statusLabel.pending': '待处理',
  'statusLabel.approved': '已批准',
  'statusLabel.rejected': '已拒绝',
  'statusLabel.unknown': '未知',
  'statusLabel.unassigned': '未分配',
  'statusLabel.unknown_project': '未知项目',

  // Checklist inline labels
  'checklist.managementDoneShort': '管理完成',
  'checklist.completeMgmtShort': '完成管理检查',
  'checklist.subDoneShort': '分包商完成',
  'checklist.completeSubShort': '完成分包商检查',
  'checklist.finalCompleteShort': '最终：完成',
  'checklist.waitingForSubShort': '等待分包商',
  'checklist.waitingForMgmtShort': '等待管理',
  'checklist.requestActionShort': '请求操作',
  'checklist.checksLabel': '项检查',
  'checklist.finalApprovalLabel': '最终批准',
  'checklist.completedLabel': '已完成',
  'checklist.requiredLabel': '必填',
  'checklist.unmappedLabel': '未映射',
  'checklist.noChecklistMappedScheduleOnly': '无清单映射 — 仅进度',
  'checklist.allItemsChecked': '所有清单项已检查。干得好！',
  'checklist.noItemsMatchFilters': '没有符合当前筛选条件的清单项。',
  'checklist.noItemsMatchFilter': '没有符合当前筛选条件的清单项。',
  'checklist.showAllItems': '显示所有项',
  'checklist.viewCheckedItems': '查看已检查项',
  'checklist.unmappedItemsCount': '{count} 个未映射',
  'checklist.noScheduleItemsInStage': '此阶段没有进度项',
  'checklist.finalApprovalComplete': '最终批准仅在所有必要批准（管理 + 分包商）完成后才算完成。',
  'checklist.waitingForSubChecks': '等待分包商确认',
  'checklist.refreshingData': '正在刷新清单数据...',
  'checklist.loadingText': '正在加载清单...',
  'checklist.failedToLoadText': '清单加载失败',
  'checklist.createChecklistBtn': '创建清单',
  'checklist.allConstructionSubStages': '所有施工子阶段',
  'checklist.allStagesOption': '所有阶段',
  'checklist.allScheduleItemsOption': '所有进度项',
  'checklist.byStageOption': '按阶段',
  'checklist.bySectionOption': '按章节',
  'checklist.selectScheduleOption': '选择进度项...',
  'checklist.mapBtn': '映射',
  'checklist.cancelBtn': '取消',
  'checklist.unmappedItemsTitle': '未映射的清单项',
  'checklist.unmappedItemsDesc': '这些项目未链接到任何进度项。请映射以整理您的清单。',

  // Tasks inline labels
  'tasks.openLabel': '未完成',
  'tasks.overdueLabel': '已逾期',
  'tasks.totalLabel': '总计',
  'tasks.noTasksLabel': '暂无任务',
  'tasks.createTaskLabel': '创建任务以开始使用',
  'tasks.noTasksAssignedLabel': '尚未分配任务',
  'tasks.loadingTasksLabel': '正在加载任务...',
  'tasks.newTaskBtn': '新建',
  'tasks.createTaskBtn': '创建任务',
  'tasks.creatingLabel': '创建中...',
  'tasks.closeBtn': '关闭',
  'tasks.dueLabel': '截止',
  'tasks.optionsCountLabel': '选项',
  'tasks.selectedLabel': '已选择',
  'tasks.invoiceDetailsLabel': '发票详情',
  'tasks.paymentStatusLabel': '付款状态',
  'tasks.referenceLabel': '参考',
  'tasks.responseLabel': '回复',
  'tasks.respondLabel': '回复',
  'tasks.typeResponseLabel': '输入回复...',
  'tasks.submitResponseBtn': '提交回复',
  'tasks.markAsPaidBtn': '标为已付款',
  'tasks.paymentRefLabel': '付款参考 / 交易ID',
  'tasks.paymentNoteLabel': '备注（可选）',
  'tasks.confirmPaymentBtn': '确认收到付款',
  'tasks.selectThisOptionBtn': '选择此选项',
  'tasks.selectionConfirmedLabel': '选择已确认',
  'tasks.addOptionBtn': '+ 添加选项',
  'tasks.optionLabelLabel': '选项标签',
  'tasks.optionDescLabel': '描述（可选）',
  'tasks.priceNoteLabel': '价格备注（可选）',
  'tasks.titleLabel': '标题 *',
  'tasks.titlePlaceholderLabel': '例：需要选择瓷砖',
  'tasks.descPlaceholderLabel': '描述需要完成的工作...',
  'tasks.invoicePlaceholderLabel': '例：PC-003',
  'tasks.amountPlaceholderLabel': '例：35000',
  'tasks.taskTypeLabel': '任务类型',
  'tasks.assignToLabel': '分配给',
  'tasks.dueDateLabel': '截止日期',
  'tasks.descriptionLabel': '描述',
  'tasks.optionsLabel2': '选项',
  'tasks.invoiceNoLabel': '发票号',
  'tasks.amountLabel': '金额（$）',
  'tasks.paymentDueDateLabel': '付款截止日期',
  'tasks.newTaskTitle': '新建任务',

  // Stages inline labels
  'stages.currentLabel': '当前',
  'stages.scheduleCompleteLabel': '进度完成',
  'stages.scheduleLabel': '进度',
  'stages.checklistFinalLabel': '清单最终',
  'stages.noChecklistMappedLabel': '无清单映射 — 仅进度',
  'stages.combinedProgressLabel': '阶段进度（综合）',
  'stages.checklistFinalApprovalLabel': '清单最终批准',
  'stages.paymentMilestonesLabel': '付款里程碑',
  'stages.backToAllLabel': '返回所有施工项',
  'stages.oneOrMoreDelayedLabel': '一个或多个项目延迟',
  'stages.notMappedLabel': '未映射到清单 — 计为完成',
  'stages.checklistCompleteLabel': '清单完成',
  'stages.checklistIncompleteLabel': '清单未完成',
  'stages.manuallyCompletedLabel': '手动完成',
  'stages.manualLabel': '手动 {pct}% — 无清单',
  'stages.noScheduleItemsInStage': '此阶段没有进度项',
  'stages.checksLabel': '项检查',
  'stages.checklistItemsLabel': '清单项',
  'stages.completedLabel': '已完成',
  'stages.delayedLabel': '延迟',
  'stages.atRiskLabel': '风险',
  'stages.completeLabel': '完成',
  'stages.mgmtPendingLabel': '管理待处理',
  'stages.subPendingLabel': '分包商待处理',
  'stages.showingItemsLabel': '显示项目',
  'stages.updateStageBtn': '更新阶段',
  'stages.cancelBtn': '取消',
  'stages.suggestedCurrentStageLabel': '建议当前阶段',
  'stages.scheduleProgressSuggestsMoving': '进度建议将此项目移至 {stage}。',
  'stages.updateProjectStageBtn': '更新项目阶段',
  'stages.dismissBtn': '关闭',
  'stages.failedToLoadStages': '阶段加载失败',
  'stages.retryBtn': '重试',
  'stages.noScheduleItemsYet': '暂无进度项',
  'stages.createScheduleFromTab': '从进度计划标签创建进度计划，以查看与清单项链接的阶段。',
  'stages.formulaLabel': '公式：进度 {sched}% x 50% + 清单 {cl}% x 50% = {combined}%',
  'stages.nilPayment': '无',

  // Schedule inline labels
  'schedule.refreshingData': '正在刷新进度数据...',
  'schedule.loadingText': '加载中...',
  'schedule.retryBtn': '重试',
  'schedule.dismissBtn': '关闭',
  'schedule.updateProjectStageBtn': '更新项目阶段',
  'schedule.scheduleProgressSuggestsMoving': '进度建议将此项目移至 {stage}。',
  'schedule.checklistFinalLabel': '清单最终',
  'schedule.scheduleFinalLabel': '进度最终',
  'schedule.projectProgressLabel': '项目进度',
  'schedule.calculatedFrom50': '由清单50% + 进度50%计算得出',
  'schedule.pendingCountLabel': '{count} 项待处理',
  'schedule.scheduleCompleteLabel': '进度完成',
  'schedule.showDetailsBtn': '显示详情',
  'schedule.hideDetailsBtn': '隐藏详情',
  'schedule.reviewPendingItemsBtn': '查看待处理项',
  'schedule.noChecklistMappingBtn': '无清单映射',
  'schedule.incompleteChecklistBtn': '清单未完成',
  'schedule.markAllPendingBtn': '将所有待处理进度项标为完成',
  'schedule.noPendingItemsBtn': '没有待处理项',
  'schedule.hideChangeHistory': '隐藏变更历史',
  'schedule.showChangeHistory': '显示变更历史',
  'schedule.noScheduleCreated': '尚未创建进度计划',
  'schedule.createFromDevTemplate': '根据 Buildertrend 进度模板创建包含156个项目的默认开发进度计划。',
  'schedule.createFromDevTemplateBtn': '从开发模板创建进度计划',
  'schedule.scheduleItemsNeedDatesDesc': '已创建 {count} 个进度项，但尚未设置时间线日期。',
  'schedule.generateInitialTimelineBtn': '生成初始时间线',
  'schedule.noItemsMatchCurrentFilter': '没有符合当前筛选条件的进度项。',
  'schedule.clearFiltersBtn': '清除筛选器',
  'schedule.setupInProgressTitle': '进度计划已导入。设置进行中。',
  'schedule.setupInProgressDesc': '在依赖关键路径提醒之前，请完成清单映射和进度跟踪。',
  'schedule.projectProgressWillReach100': '将所有待处理进度项标为完成后，项目进度将达到100%。',
  'schedule.markAllConfirmTitle': '将所有待处理项标为完成？',
  'schedule.markAllConfirmDesc': '将 {count} 个进度项标为最终进度100%完成。已完成的项目不受影响。',
  'schedule.markAllWarningText': '此操作不易撤销。无论清单状态如何，所有待处理进度项都将设置为完成。',
  'schedule.markingLabel': '标记中...',
  'schedule.markCountCompleteBtn': '将 {count} 项标为完成',
  'schedule.cancelBtn': '取消',
  'schedule.recalcCriticalPathTitle': '重新计算关键路径？',
  'schedule.recalcCriticalPathDesc': '将从当前进度项和链接计算关键路径，然后将 is_critical 标志保存到 Supabase。',
  'schedule.recalcCriticalPathWarning': '重新计算后将启用关键路径提醒。不在关键路径上的项目将清除其关键标志。',
  'schedule.calculatingLabel': '计算中...',
  'schedule.recalcAndSaveBtn': '重新计算并保存',

  // Instructions inline labels
  'instructions.changeOrderLabel': '变更单',
  'instructions.clientApprovalLabel': '客户批准',
  'instructions.linkedScheduleLabel': '关联进度',
  'instructions.linkedChecklistLabel': '关联清单',
  'instructions.linkedPhotoLabel': '关联照片',
  'instructions.changeOrderDetailsLabel': '变更单详情',
  'instructions.reasonLabel': '原因',
  'instructions.currentLabel': '当前',
  'instructions.newLabel': '新',
  'instructions.costLabel': '费用',
  'instructions.scheduleLabel': '进度',
  'instructions.managementNoteLabel': '管理备注',
  'instructions.readMoreBtn': '阅读更多',
  'instructions.showLessBtn': '收起',
  'instructions.markCompletedBtn': '标为完成',
  'instructions.markClosedBtn': '标为关闭',
  'instructions.acknowledgedLabel': '已确认',
  'instructions.completedLabel': '已完成',
  'instructions.readLabel': '已读',
  'instructions.noInstructionsYet': '暂无指令',
  'instructions.createInstructionDesc': '创建指令以发送给分包商',
  'instructions.createChangeOrderBtn': '创建变更单',
  'instructions.createFirstInstructionBtn': '创建第一条指令',
  'instructions.changeOrderBtn': '变更单',
  'instructions.newInstructionBtn': '新建指令',

  // Payments inline labels
  'payments.title': '付款',
  'payments.addPayment': '添加付款',
  'payments.editPayment': '编辑付款',
  'payments.addFirstPayment': '添加第一笔付款',
  'payments.addPaymentItem': '添加付款项',
  'payments.noPaymentSchedule': '暂无付款计划',
  'payments.addPaymentMilestones': '为此项目添加付款里程碑',
  'payments.total': '总计',
  'payments.paid': '已付款',
  'payments.remaining': '剩余',
  'payments.clientNotified': '客户已在门户中收到通知',
  'payments.clientNotifiedPayment': '客户已通知付款',
  'payments.confirmPaymentReceived': '确认收到付款',
  'payments.saveChanges': '保存更改',
  'payments.cancel': '取消',
  'payments.delete': '删除',
  'payments.titleLabel': '标题',
  'payments.descriptionLabel': '描述',
  'payments.amountLabel': '金额（NZD）',
  'payments.dueDateLabel': '截止日期',
  'payments.statusLabel': '状态',
  'payments.paymentReferenceLabel': '付款参考',
  'payments.paymentDateLabel': '付款日期',
  'payments.amountPaidLabel': '已付金额',
  'payments.referenceLabel': '参考',
  'payments.noteLabel': '备注',
  'payments.optional': '（可选）',
  'payments.required': '*',
  'payments.upcoming': '即将到来',
  'payments.dueNowStatus': '立即到期',
  'payments.overdueStatus': '已逾期',
  'payments.paidStatus': '已付款',
  'payments.pendingConfirmationStatus': '待确认',
  'payments.daysOverdue': '逾期{n}天',
  'payments.dueToday': '今日到期',
  'payments.dueInDays': '{n}天后到期',
  'payments.reviewAndConfirm': '客户已通知付款完成。请在下方确认。',

  // Notification detail sheet
  'notifDetail.images': '张图片',
  'notifDetail.image': '张图片',
  'notifDetail.files': '个文件',
  'notifDetail.file': '个文件',

  // Tasks type/status/role labels
  'tasks.typeGeneral': '一般',
  'tasks.typeDecision': '决策',
  'tasks.typeSelection': '选择',
  'tasks.typePayment': '付款',
  'tasks.typeApproval': '审批',
  'tasks.typeInformation': '信息',
  'tasks.statusPending': '待处理',
  'tasks.statusAwaitingResponse': '等待回复',
  'tasks.statusCompleted': '已完成',
  'tasks.statusOverdue': '已逾期',
  'tasks.statusCancelled': '已取消',
  'tasks.payStatusNA': 'N/A',
  'tasks.payStatusUnpaid': '未付款',
  'tasks.payStatusPartial': '部分付款',
  'tasks.payStatusPaid': '已付款',
  'tasks.payStatusOverdue': '已逾期',
  'tasks.roleManagement': '管理',
  'tasks.roleSubcontractor': '分包商',
  'tasks.roleClient': '客户',
  'tasks.roleAllParties': '所有方',
  'tasks.filterAll': '全部',
  'tasks.filterOpen': '未完成',
  'tasks.filterDecision': '决策',
  'tasks.filterPayment': '付款',
  'tasks.filterOverdue': '已逾期',
  'tasks.filterCompleted': '已完成',

  // Stages status labels
  'stages.statusNotStarted': '未开始',
  'stages.statusInProgress': '进行中',
  'stages.statusCompleted': '已完成',
  'stages.statusDelayed': '延迟',

  // Payments status labels
  'payments.statusUpcoming': '即将到来',
  'payments.statusDueNow': '立即到期',
  'payments.statusOverdue': '已逾期',
  'payments.statusPaid': '已付款',
  'payments.statusPendingConfirmation': '待确认',

  // NewProject wizard additional keys
  'newProject.info': '信息',
  'newProject.type': '类型',
  'newProject.scheduleSetupStep': '进度设置',
  'newProject.cover': '封面',
  'newProject.team': '团队',
  'newProject.stagesStep': '阶段',
  'newProject.scheduleStep': '进度',
  'newProject.paymentsStep': '付款',
  'newProject.review': '确认',
  'newProject.development': '开发',
  'newProject.renovation': '翻新',
  'newProject.other': '其他',
  'newProject.scheduleSource': '进度来源',
  'newProject.useDefaultTemplate': '使用默认模板',
  'newProject.copyFromExisting': '从现有项目复制',
  'newProject.createScheduleLater': '稍后创建进度计划',
  'newProject.createDefaultSchedule': '创建默认进度计划',
  'newProject.includeDependencyLinks': '包含依赖关系链接',
  'newProject.generateInitialTimeline': '立即生成初始时间线',
  'newProject.scheduleStartDate': '进度开始日期',
  'newProject.workingDays': '工作日',
  'newProject.workingDaysDesc': '默认：周一至周六，不包括周日和新西兰公假日。',
  'newProject.noTemplateSchedule': '不会创建模板进度计划。您可以稍后从进度标签添加。',
  'newProject.selectProjectToCopy': '选择要复制进度计划的项目',
  'newProject.loadingProjects': '正在加载项目...',
  'newProject.chooseExistingProject': '选择现有项目...',
  'newProject.scheduleItems': '进度项',
  'newProject.pleaseSelectProject': '请选择要复制进度计划的项目。',
  'newProject.noExistingProjects': '未找到具有进度计划的现有项目。',
  'newProject.sourceProjectSummary': '源项目摘要',
  'newProject.loadingSummary': '正在加载摘要...',
  'newProject.scheduleItemsLabel': '进度项',
  'newProject.stagesLabel2': '阶段',
  'newProject.dependencyLinks': '依赖关系链接',
  'newProject.available': '可用',
  'newProject.notAvailable': '不可用',
  'newProject.originalDateRange': '原始日期范围',
  'newProject.checklistMappings': '清单映射',
  'newProject.couldNotLoadSummary': '无法加载项目摘要。',
  'newProject.copyOptions': '复制选项',
  'newProject.copyScheduleItems': '复制进度项',
  'newProject.copyStages': '复制阶段',
  'newProject.copyDependencyLinks': '复制依赖关系链接',
  'newProject.copyChecklistMappings': '复制清单映射',
  'newProject.copyChecklistMappingsDesc': '仅当进度项和清单兼容时',
  'newProject.dateHandling': '日期处理',
  'newProject.generateTimelineFromStart': '从新项目开始日期生成时间线',
  'newProject.preservesDurations': '保留持续时间，重新计算开始/结束日期',
  'newProject.newProjectStartDate': '新项目开始日期',
  'newProject.useProjectStartDate': '使用项目开始日期',
  'newProject.itemsCopiedWithDurationsOnly': '项目将仅以持续时间复制。在稍后生成时间线之前，不会设置开始/结束日期。',
  'newProject.completionStatusNotCopied': '源项目的完成状态和实际日期不会被复制。新项目进度计划将重新开始。',
  'newProject.noScheduleWillBeCreated': '现在不会创建进度计划。',
  'newProject.createOrImportLater': '项目创建后，您可以从进度标签创建或导入进度计划。',
  'newProject.afterCreationScheduleTab': '创建后，进度标签将显示空状态，提供构建自定义进度、应用模板或从其他项目复制的选项。',
  'newProject.uploadOrLeaveBlank': '上传照片或留空使用默认',
  'newProject.coverPreview': '封面预览',
  'newProject.customPhoto': '自定义照片',
  'newProject.defaultCover': '默认封面',
  'newProject.clickOrDragDrop': '点击或拖放上传',
  'newProject.jpgPngWebp': 'JPG、PNG、WebP — 最大5MB',
  'newProject.uploading': '上传中...',
  'newProject.orPasteUrl': '或粘贴URL',
  'newProject.coverPhotoUrl': '封面照片URL',
  'newProject.coverUrlPlaceholder': 'https://...（使用默认则留空）',
  'newProject.resetToDefault': '重置为默认封面',
  'newProject.defaultCoversByType': '按项目类型的默认封面：',
  'newProject.developmentCoverDesc': '开发 — 木框架 / 新建建筑图片',
  'newProject.renovationCoverDesc': '翻新 — 室内改造 / 厨房翻新图片',
  'newProject.changeCoverAnytime': '您可以随时从编辑项目 → 类型和封面更改封面照片。',
  'newProject.optionalAddTeam': '可选 — 添加分包商和客户。您也可以稍后添加。',
  'newProject.existingAccountsAdded': '现有账户将立即添加',
  'newProject.ifEmailHasAccount': '如果电子邮件已有账户，将被添加到此项目。新账户需要部署边缘函数—如果失败，项目仍会创建，您可以稍后添加团队成员。',
  'newProject.optionalSetTimeline': '可选 — 设置整体项目时间线。可稍后编辑。',
  'newProject.stageDatesFromEdit': '阶段日期可在创建后从编辑项目 → 阶段设置。',
  'newProject.monthsDuration': '{n}个月时长',
  'newProject.weeksDuration': '{n}周时长',
  'newProject.weekDuration': '{n}周时长',
  'newProject.daysDuration': '{n}天时长',
  'newProject.dayDuration': '{n}天时长',
  'newProject.setUpPaymentNow': '现在设置付款计划',
  'newProject.addLaterFromEdit': '您也可以稍后从编辑项目添加',
  'newProject.noPaymentsAdded': '尚未添加付款',
  'newProject.startFromTemplate': '从模板开始或手动添加项目',
  'newProject.loadStandardTemplate': '加载标准模板',
  'newProject.addManually': '手动添加',
  'newProject.payment': '付款',
  'newProject.done': '完成',
  'newProject.titleRequired': '标题',
  'newProject.descriptionOptional': '描述',
  'newProject.amountNZD': '金额（NZD）',
  'newProject.dueDate': '截止日期',
  'newProject.reference': '参考',
  'newProject.untitledPayment': '无标题付款',
  'newProject.noAmountSet': '未设置金额',
  'newProject.addPaymentItem': '添加付款项',
  'newProject.totalScheduled': '计划总计',
  'newProject.setUpPaymentLater': '您可以稍后从编辑项目 → 付款标签设置付款计划。',
  'newProject.confirmDetails': '创建前请确认所有详情',
  'newProject.projectCreatedSuccess': '项目创建成功！',
  'newProject.noAddress': '无地址',
  'newProject.projectDetailsSection': '项目详情',
  'newProject.projectNameLabel': '项目名称',
  'newProject.siteAddressLabel': '施工地址',
  'newProject.clientLabel': '客户',
  'newProject.typeLabel': '类型',
  'newProject.startDateLabel': '开始日期',
  'newProject.estCompletionLabel': '预计完成',
  'newProject.notSet': '未设置',
  'newProject.scheduleSetupSection': '进度设置',
  'newProject.createDefaultFromTemplate': '从模板创建默认进度计划',
  'newProject.includeDependencyLinksLabel': '包含依赖关系链接',
  'newProject.generateTimelineFrom': '生成初始时间线',
  'newProject.copyScheduleFromExisting': '从现有项目复制进度计划',
  'newProject.copyScheduleItemsLabel': '复制进度项',
  'newProject.copyStagesLabel': '复制阶段',
  'newProject.copyDependencyLinksLabel': '复制依赖关系链接',
  'newProject.copyChecklistMappingsLabel': '复制清单映射',
  'newProject.recalculateDatesLabel': '从新开始日期重新计算日期',
  'newProject.copyAsUndated': '以无日期进度计划复制（仅持续时间）',
  'newProject.noDefaultSchedule': '无默认进度计划 — 可稍后从进度标签添加',
  'newProject.stagesSection': '阶段',
  'newProject.teamSection': '团队',
  'newProject.paymentScheduleSection': '付款计划',
  'newProject.paymentItems': '项',
  'newProject.total': '总计',
  'newProject.noPaymentScheduleNote': '无付款计划 — 可稍后从编辑项目添加',
  'newProject.readyToCreateDesc': '将自动生成唯一项目代码。项目将通过直接数据库插入立即创建。',
  'newProject.renovationTemplateNotConfigured': '翻新进度计划模板尚未配置。',
  'newProject.canStillCreateProject': '您仍可以创建项目，稍后从进度标签设置进度计划。',
  'newProject.customPhotoSet': '已设置自定义照片',
  'newProject.autoUsedUnlessCustom': '除非您上传自定义封面照片，否则将自动使用此图片。',
  'newProject.defaultCoverPhoto': '默认封面照片',
  'newProject.defaultCoverLabel': '{type} 默认封面',

  // New project creation result status
  'newProject.scheduleCreatedOk': '进度计划创建成功',
  'newProject.scheduleNotCreated': '进度计划未创建 — 可以从进度标签添加',
  'newProject.checklistCreatedOk': '清单创建成功',
  'newProject.checklistNotCreated': '清单创建失败',
  'newProject.checklistNotCreatedDesc': '打开项目后，可以从清单标签创建默认清单。',

  // Checklist setup in new project wizard
  'newProject.createDefaultChecklist': '创建默认清单',
  'newProject.createDefaultChecklistDesc': '复制此项目类型的默认清单模板。',
  'newProject.createDefaultChecklistLaterDesc': '复制默认清单模板。进度计划可稍后添加。',
  'newProject.createDefaultChecklistLabel': '从模板创建默认清单',
  'newProject.linkChecklistToSchedule': '将清单链接到进度计划',
  'newProject.linkChecklistToScheduleDesc': '根据阶段/阶段将清单项映射到进度项。',
  'newProject.noTemplateScheduleChecklist': '不会创建模板进度计划或清单。您可以稍后从进度和清单标签添加。',
  'newProject.copyChecklistItems': '复制清单项',
  'newProject.copyChecklistItemsDesc': '复制源项目的所有清单项，重置为未完成。',
  'newProject.copyChecklistItemsLabel': '复制清单项',
  'newProject.resetChecklistCompletion': '重置所有完成状态',
  'newProject.resetChecklistCompletionDesc': '所有复制的清单项将以未完成状态开始。',
  'newProject.checklistsLabel': '清单',
  'newProject.checklistItemsLabel': '清单项',
  'newProject.checklistItems': '清单项',

  // Checklist mobile labels
  'checklist.mgmtPending': '管理待处理',
  'checklist.subPending': '分包商待处理',
  'checklist.pending': '待处理',
  'checklist.completed': '已完成',

  // ChecklistItemCard keys
  'checklistCard.complete': '完成',
  'checklistCard.required': '必填',
  'checklistCard.mgmtPending': '管理待处理',
  'checklistCard.subPending': '分包商待处理',
  'checklistCard.mgmt': '管理',
  'checklistCard.sub': '分包商',
  'checklistCard.markAsIncomplete': '标为未完成',
  'checklistCard.markAsComplete': '标为完成',
  'checklistCard.completed': '已完成',
  'checklistCard.awaitingMgmt': '等待管理确认',
  'checklistCard.awaitingSubcontractor': '等待分包商确认',
  'checklistCard.checkedRecently': '最近',
  'checklistCard.notes': '备注',
  'checklistCard.management': '管理',
  'checklistCard.subcontractor': '分包商',

  // Instructions priority labels
  'priority.high': '高',
  'priority.medium': '中',
  'priority.low': '低',
  'priority.allPriorities': '所有优先级',

  // Date/time formatting
  'date.today': '今天',
  'date.nonWorkday': '非工作日',
  'date.publicHoliday': '公假日',
  'date.offDay': '休息',
  'date.month': '月',
  'date.week': '周',
  'date.day': '日',

  // Notifications additional
  'notifications.markAsRead': '标为已读',
  'notifications.newNotification': '新通知',
  'notifications.emailSent': '邮件通知已发送',
  'notifications.emailFailed': '邮件通知失败',

  // Files additional
  'files.fileName': '文件名',
  'files.fileType': '文件类型',
  'files.uploadedBy': '上传者',
  'files.uploadedDate': '上传日期',
  'files.visibleToClient': '客户可见',
  'files.managementOnly': '仅管理可见',
  'files.uploadFile': '上传文件',

  // Daily Log additional
  'dailyLog.uploadedBy': '上传者',
  'dailyLog.uploadedDate': '上传日期',
  'dailyLog.reviewPhotos': '审查照片',
  'dailyLog.pendingManagementReview': '待管理审查',
  'dailyLog.approveForClientBtn': '批准给客户',
  'dailyLog.keepInternalBtn': '保持内部',

  // Payments additional
  'payments.paymentSchedule': '付款计划',
  'payments.amount': '金额',
  'payments.paymentConfirmed': '付款已确认',
  'payments.awaitingConfirmation': '待确认',
  'payments.unpaid': '未付款',

  // Tasks additional
  'tasks.internalTask': '内部任务',
  'tasks.clientTask': '客户任务',
  'tasks.priority': '优先级',
  'tasks.paymentTask': '付款任务',
  'tasks.decisionTask': '决策任务',
  'tasks.generalTask': '一般任务',

  // Checklist filter labels
  'checklist.filterAll': '全部',
  'checklist.filterUnchecked': '未检查',
  'checklist.filterChecked': '已检查',
  'checklist.filterWaitMgmt': '等待管理',
  'checklist.filterWaitSub': '等待分包商',
  'checklist.filterFullyApproved': '完全批准',
  'checklist.filterUnmapped': '未映射',
  'checklist.checksCount': '项检查',
  'checklist.stageProgress': '{stage} 进度',
  'checklist.mgmtLabel': '管理',
  'checklist.subLabel': '分包商',
  'checklist.finalLabel': '最终',
  'checklist.paymentPercent': '{n}% 付款',

  // Schedule hardcoded strings
  'schedule.refreshingScheduleData': '正在刷新进度数据...',
  'schedule.scheduleProgressSuggestsMoving': '进度建议将此项目移至 {stage}。',
  'schedule.dismiss': '关闭',
  'schedule.updateProjectStage': '更新项目阶段',
  'schedule.checklistFinalColon': '清单最终:',
  'schedule.scheduleFinalColon': '进度最终:',
  'schedule.projectProgressColon': '项目进度:',
  'schedule.calculatedFrom50Pct': '由清升50% + 进度50%计算得出',
  'schedule.projectProgressWillReach': '将所有待处理进度项标为完成后，项目进度将达到100%。',
  'schedule.scheduleCompleteAll': '进度最终: {pct}% — 全部 {total} 项完成',
  'schedule.pendingItemsCount': '{count} 个进度项待处理',
  'schedule.noMappingIncomplete': '{count} 个项目没有清单映射且仍未完成。请手动完成或映射到清单项目。',
  'schedule.incompleteLinkedChecklist': '{count} 个项目有未完成的关联清单。',
  'schedule.completedNotLinked': '{count} 个已完成项目未关联清单项目。它们仍计为完成。',
  'schedule.markAllPendingComplete': '将所有待处理进度项标为完成',
  'schedule.noPendingItems': '没有待处理项',
  'schedule.reviewPendingItemsBtn': '查看待处理项',
  'schedule.noChecklistMappingBtn': '无清单映射',
  'schedule.incompleteChecklistBtn': '清单未完成',
  'schedule.hideChangeHistory': '隐藏变更历史',
  'schedule.showChangeHistory': '显示变更历史',
  'schedule.noScheduleCreatedDesc': '根据 Buildertrend 进度模板创建包含156个项目的默认开发进度计划。',
  'schedule.createFromDevTemplateBtn': '从开发模板创建进度计划',
  'schedule.scheduleItemsNeedDatesDesc': '已创建 {count} 个进度项，但尚未设置时间线日期。',
  'schedule.generateInitialTimelineBtn': '生成初始时间线',
  'schedule.noItemsMatchCurrentFilter': '没有符合当前筛选条件的进度项。',
  'schedule.clearFiltersBtn': '清除筛选器',
  'schedule.setupInProgressTitle': '进度计划已导入。设置进行中。',
  'schedule.setupInProgressDesc': '在依赖关键路径提醒之前，请完成清单映射和进度跟踪。关键路径分析默认禁用。',
  'schedule.markAllConfirmTitle': '将所有待处理项标为完成？',
  'schedule.markAllConfirmDesc': '将 {count} 个进度项标为最终进度100%完成。已完成的项目不受影响。',
  'schedule.markAllWarningText': '此操作不易撤销。无论清单状态如何，所有待处理进度项都将设置为完成。',
  'schedule.markingLabel': '标记中...',
  'schedule.markCountCompleteBtn': '将 {count} 项标为完成',
  'schedule.cancelBtn': '取消',
  'schedule.recalcCriticalPathTitle': '重新计算关键路径？',
  'schedule.recalcCriticalPathDesc': '将从当前进度项和链接计算关键路径，然后将 is_critical 标志保存到 Supabase。',
  'schedule.recalcCriticalPathWarning': '重新计算后将启用关键路径提醒。不在关键路径上的项目将清除其关键标志。',
  'schedule.calculatingLabel': '计算中...',
  'schedule.recalcAndSaveBtn': '重新计算并保存',
  'schedule.retryBtn': '重试',

  // Instructions tab hardcoded strings
  'instructions.changeOrderBadge': '变更单',
  'instructions.clientApprovalBadge': '客户批准',
  'instructions.linkedScheduleBadge': '关联进度',
  'instructions.linkedChecklistBadge': '关联清单',
  'instructions.linkedPhotoBadge': '关联照片',
  'instructions.changeOrderDetailTitle': '变更单详情',
  'instructions.reasonColon': '原因：',
  'instructions.currentColon': '当前：',
  'instructions.newColon': '新：',
  'instructions.costColon': '费用：',
  'instructions.scheduleColon': '进度：',
  'instructions.managementNoteTitle': '管理备注',
  'instructions.readMoreBtn': '阅读更多',
  'instructions.showLessBtn': '收起',
  'instructions.markCompletedBtn': '标为完成',
  'instructions.markClosedBtn': '标为关闭',
  'instructions.acknowledgedBadge': '已确认',
  'instructions.completedBadge': '已完成',
  'instructions.readBadge': '已读',
  'instructions.highPriorityBadge': '高优先级',
  'instructions.responseRequiredBadge': '需要回复',
  'instructions.changeOrderBtn2': '变更单',
  'instructions.newInstructionBtn2': '新建指令',
  'instructions.createChangeOrderBtn2': '创建变更单',
  'instructions.createFirstInstructionBtn2': '创建第一条指令',
  'instructions.noInstructionsYetMsg': '暂无指令',
  'instructions.createInstructionMsg': '创建指令以发送给分包商',
  'instructions.noStatusInstructions': '没有{status}指令',
  'instructions.toLabel': '收件人：',
  'instructions.dueLabel': '截止',

  // Notifications filter types
  'notifications.filterAll': '全部',
  'notifications.filterProgress': '进度',
  'notifications.filterIssue': '问题',
  'notifications.filterApproval': '审批',
  'notifications.filterQuestion': '问题',
  'notifications.filterTask': '任务',
  'notifications.filterPayment': '付款',
  'notifications.filterUpdate': '更新',
  'notifications.filterPhoto': '照片',
  'notifications.filterFile': '文件',

  // Daily Log toast messages
  'dailyLog.toastTitleRequired': '请输入标题并选择照片',
  'dailyLog.toastCreatedSuccess': '日志创建成功',
  'dailyLog.toastCreateFailed': '日志创建失败',

  // Daily Log created entries list
  'dailyLog.createdDailyLogs': '已创建的日志',
  'dailyLog.untitledDailyLog': '未命名日志',
  'dailyLog.viewDailyLog': '查看日志',
  'dailyLog.view': '查看',
  'dailyLog.previewAsClient': '以客户视角预览',
  'dailyLog.loadingDailyLogs': '正在加载日志...',

  // NewProject type descriptions
  'newProject.developmentDesc': '新建工程。包括土地开发、新建和多单元项目。',
  'newProject.renovationDesc': '现有建筑的升级或改造。包括全面翻新、扩建和装修。',
  'newProject.otherDesc': '自定义或混合用途项目。进度计划可在项目创建后从进度标签配置。',

  // Stages progress percent label
  'stages.progressPct': '{pct}% 进度',
  'stages.paymentPercent': '{n}% 付款',
  'stages.currentStageLabel': '当前阶段',
  'stages.notSet': '未设定',
  'stages.setStageBtn': '设定阶段',
  'stages.noItemsYet': '暂无条目 — 0%',
  'stages.moveToPrev': '返回上一阶段',
  'stages.moveToNext': '进入下一阶段',
  'stages.movedToStageToast': '项目已移至{stage}',
  'stages.unassignedStage': '未分配',
  'stages.unassignedDesc': '未分配阶段的任务 — 请在进度表标签页中分配。这些任务不会阻碍阶段推进。',
  'stages.moveAllToConstructionBtn': '全部移至施工',
  'stages.movedUnassignedToConstructionToast': '已将 {count} 个任务移至施工',
  'stages.moveUnassignedFailed': '无法将任务移至施工，请重试。',
  'stages.moveStageAnywayTitle': '移动项目阶段？',
  'stages.moveStageAnywayConfirm': '{stages}有未完成项目。仍要移至{stage}吗？',
  'stages.moveStageAnywayBtn': '仍要移动',
  'stages.stageUpdateFailed': '无法更新项目阶段，请重试。',
  'stages.checksCount': '{n} 项检查',
  'stages.checklistItemsCount': '{n} 个清单项',
  'stages.completedCount': '{n} 已完成',
  'stages.mgmtCount': '管理 {checked}/{total}',
  'stages.subCount': '分包商 {checked}/{total}',

  // FileUploader shared component
  'upload.title': '上传',
  'upload.takePhoto': '拍照',
  'upload.choosePhotos': '选择照片',
  'upload.uploadFile': '上传文件',
  'upload.dropFilesHere': '将文件拖放到此处，或点击选择',
  'upload.selectPhotos': '选择照片',
  'upload.selectFiles': '选择文件',
  'upload.addCaption': '添加说明...',
  'upload.uploading': '上传中…',
  'upload.retryFailed': '重试失败项',
  'upload.done': '完成',
  'upload.upload': '上传',
  'upload.file': '个文件',
  'upload.files': '个文件',
  'upload.selected': '已选择',
  'upload.uploaded': '已上传',
  'upload.closingMoment': '即将关闭…',
  'upload.fileTooLarge': '文件过大（最大 {max}）',
  'upload.totalExceeds': '总上传大小超过 {max}',
  'upload.maxFiles': '最多 {max} 个文件',
  'upload.notAnImage': '不是图片。只允许上传照片。',
  'upload.pdfNotAllowed': '不允许上传PDF文件。',
  'upload.addCaptionFor': '请为 {count} 个文件添加说明',
  'upload.addCaptionForPlural': '请为 {count} 个文件添加说明',
  'upload.jpgPngWebpHeic': 'JPG、PNG、WebP、HEIC',
  'upload.jpgPngPdfDocs': 'JPG、PNG、PDF、文档',
  'upload.jpgPngDocs': 'JPG、PNG、文档',
  'upload.maxEach': '每个最大 {max}',

  // PhotoLightbox
  'lightbox.pinchToZoom': '捆放缩放 · 滑动导航',
  'lightbox.imageCouldNotLoad': '图片无法加载',

  // ProjectDetail hardcoded strings
  'projectDetail.noAddressSet': '未设置地址',
  'projectDetail.description': '描述',
  'projectDetail.reviewPendingSchedule': '查看待处理进度',
  'projectDetail.pendingScheduleItems': '{count} 个进度项待处理',
  'projectDetail.checklistItemsPending': '{count} 个清单项待处理',
  'projectDetail.checklistFinalPct': '清单最终: {pct}%',
  'projectDetail.scheduleFinalPct': '进度最终: {pct}%',
  'projectDetail.projectProgressPct': '{pct}% 项目进度',
  'projectDetail.scheduleFormula': '进度最终 {sched}% × 50% + 清单最终 {cl}% × 50% = {total}% 项目进度',
  'projectDetail.checklistComplete100': '清单已100%完成。由于进度最终为 {schedPct}%，项目进度停止在 {pct}%。',
  'projectDetail.progressFormula': '项目进度 = 进度最终50% + 清单最终50%。要达到100%，请完成两者。',
  'projectDetail.viewPendingItems': '查看待处理项',
  'projectDetail.mgmtChecksComplete': '管理检查完成。等待分包商确认。',
  'projectDetail.subPendingDesc': '{remaining} / {total} 个分包商必填清单项仍待确认。',
  'projectDetail.scheduleProgressSuggestsMoving': '进度建议将此项目移至下一阶段',
  'projectDetail.updateProjectStage': '更新项目阶段',
  'projectDetail.dismiss': '关闭',

  // Checklist recovery flow
  'checklist.createDefaultChecklistForProject': '为此项目创建默认清单',
  'checklist.creatingDefaultChecklist': '正在创建清单...',
  'checklist.defaultChecklistCreated': '已创建包含 {count} 个项目的默认清单。',
  'checklist.defaultChecklistExists': '此项目已存在清单。',
  'checklist.failedToCreateDefault': '创建默认清单失败，请重试。',
  'checklist.checklistCreatedSuccess': '清单创建成功！',
  'checklist.checklistCreationFailed': '清单创建失败',
  'checklist.checklistRecoveryNote': '将为此项目类型创建所有活跃的清单模板。',

  // Checklist by-section hardcoded strings
  'checklist.finalCompleteLabel': '最终：完成',
  'checklist.waitingForSubLabel': '等待分包商',
  'checklist.waitingForMgmtLabel': '等待管理',
  'checklist.allItemsCheckedGreat': '所有清单项已检查。干得好！',
  'checklist.viewCheckedItemsBtn': '查看已检查项',

  // Notifications type badge
  'notifType.progress': '进度',
  'notifType.issue': '问题',
  'notifType.inspection': '检查',
  'notifType.approval': '审批',
  'notifType.question': '问题',
  'notifType.task': '任务',
  'notifType.system': '系统',
  'notifType.payment': '付款',
  'notifType.update': '更新',
  'notifType.photo': '照片',
  'notifType.file': '文件',
  'notifType.schedule': '进度计划',
  'notifType.instruction': '指令',
  'notifType.checklist': '清单',

  // Instructions page All filter
  'instructions.filterAll': '全部',

  // Daily Log note prefix
  'dailyLog.notePrefix': '备注:',
  'dailyLog.failedToSaveNote': '保存备注失败: ',
  'dailyLog.failedToDelete': '删除失败: ',
  'dailyLog.actionRequired': '需要操作: ',

  // StagesTab progress label
  'stages.progressLabel': '{pct}% 进度',
  'stages.paymentLabel': '{n}% 付款',
  'stages.nilPaymentLabel': '无',

  // ScheduleItemModal
  'scheduleModal.editItem': '编辑进度项',
  'scheduleModal.addItem': '添加进度项',
  'scheduleModal.basicInfo': '基本信息',
  'scheduleModal.datesProgress': '日期与进度',
  'scheduleModal.linkedScheduleItems': '关联进度项',
  'scheduleModal.linkedChecklistItems': '关联清单项',
  'scheduleModal.checklistCompletionSummary': '清单完成摘要',
  'scheduleModal.ganttBarColor': '甘特图条颜色',
  'scheduleModal.notesTask': '备注与任务',
  'scheduleModal.titleLabel': '标题 *',
  'scheduleModal.phaseLabel': '阶段',
  'scheduleModal.stageLabel': '阶段',
  'scheduleModal.selectStage': '-- 选择阶段 --',
  'scheduleModal.constructionSubStage': '施工子阶段',
  'scheduleModal.selectSubStage': '-- 选择子阶段 --',
  'scheduleModal.durationLabel': '工期（工作日）',
  'scheduleModal.assignedRole': '分配角色',
  'scheduleModal.assignedTo': '分配给',
  'scheduleModal.startDate': '开始日期',
  'scheduleModal.endDate': '结束日期',
  'scheduleModal.progressLabel': '进度（%）',
  'scheduleModal.baselineStart': '基准开始',
  'scheduleModal.baselineEnd': '基准结束',
  'scheduleModal.actualStart': '实际开始',
  'scheduleModal.actualEnd': '实际结束',
  'scheduleModal.delayStatus': '延迟状态',
  'scheduleModal.riskLevel': '风险级别',
  'scheduleModal.auto': '自动',
  'scheduleModal.complete': '完成',
  'scheduleModal.locked': '锁定',
  'scheduleModal.noChecklist': '无清单',
  'scheduleModal.includedInProject': '包含在项目中',
  'scheduleModal.criticalPath': '关键路径',
  'scheduleModal.notSet': '未设置',
  'scheduleModal.checklistProgress': '清单进度',
  'scheduleModal.completed': '已完成',
  'scheduleModal.progress': '进度',
  'scheduleModal.mgmtChecked': '管理已检查',
  'scheduleModal.subChecked': '分包商已检查',
  'scheduleModal.missing': '缺少',
  'scheduleModal.totalLinked': '关联总计',
  'scheduleModal.mgmtChecksPending': '管理检查待处理',
  'scheduleModal.subChecksPending': '分包商检查待处理',
  'scheduleModal.openLinkedChecklist': '打开关联清单',
  'scheduleModal.notesLabel': '备注',
  'scheduleModal.delayReason': '延迟原因',
  'scheduleModal.reasonForChange': '变更原因',
  'scheduleModal.reasonOptional': '（重大变更建议填写）',
  'scheduleModal.publishToClient': '将进度更新发布给客户',
  'scheduleModal.publishDesc': '勾选后，将向项目更新发布客户可见的进度更新。',
  'scheduleModal.saving': '保存中...',
  'scheduleModal.saveChanges': '保存更改',
  'scheduleModal.addItemBtn': '添加项目',
  'scheduleModal.createTask': '从此进度项创建任务',
  'scheduleModal.sendInstruction': '向分包商发送指令',
  'scheduleModal.recalcDownstream': '重新计算下游项目？',
  'scheduleModal.recalcDesc': '此项目有关联的后继项目。更改工期将会移动其日期。是否重新计算所有下游项目？',
  'scheduleModal.saveOnly': '仅保存',
  'scheduleModal.saveAndRecalc': '保存并重新计算',
  'scheduleModal.moveToNextWorkingDay': '移至下一个工作日',
  'scheduleModal.keepThisDate': '保持此日期',
  'scheduleModal.notWorkingDay': '此日期（{day}）根据当前进度设置不是工作日。',
  'scheduleModal.progressDerivedFromChecklist': '进度来自关联清单的完成情况。',
  'scheduleModal.readyToComplete': '准备完成 — 所有清单项已完成',
  'scheduleModal.notReady': '未准备 — {completed} / {total} 个清单项已完成',
  'scheduleModal.mgmtChecksPendingDesc': '{count} 个清单项需要管理审批',
  'scheduleModal.subChecksPendingDesc': '{count} 个清单项需要分包商审批',
  'scheduleModal.actionRequired': '需要操作: ',
  'scheduleModal.deleteItem': '删除计划项目',
  'scheduleModal.deleteItemTitle': '删除计划项目？',
  'scheduleModal.deleteItemConfirm': '确定要删除这个计划项目吗？该项目将从计划中删除，所有依赖关系链接也将一并删除。',
  'scheduleModal.deleteItemWarning': '此操作不可逆转，所有关联的依存关系也将被删除。',
  'scheduleModal.deleteConfirmBtn': '删除项目',
  'scheduleModal.cancelBtn': '取消',

  // Schedule mobile timeline/card labels
  'schedule.daySingular': '天',
  'schedule.dayPlural': '天',
  'schedule.linkSingular': '链接',
  'schedule.linkPlural': '链接',
  'schedule.noDate': '无日期',
  'schedule.uncategorized': '未分类',
  'schedule.ganttSwipeHint': '左右滑动查看完整甘特图。',

  // Stage names
  'stage.Planning': '规划',
  'stage.Design': '设计',
  'stage.Consent': '审批',
  'stage.Construction': '施工',
  'stage.Handover': '交付',

  // Checklist empty state new keys
  'checklist.noChecklistItemsDesc': '此项目尚未创建清单项目。',
  'checklist.refreshPage': '刷新页面',
  'checklist.forceReload': '强制重载清单',
  'checklist.forceReloadChecklist': '强制重载清单数据',

  // ProjectDetail new keys
  'projectDetail.pending': '待处理',
  'projectDetail.reviewSchedule': '查看进度表',
  'projectDetail.reviewChecklist': '查看清单',
  'projectDetail.scheduleItemsPending': '个进度项待处理',
  'projectDetail.checklistItemsPendingShort': '个清单项待处理',
  'projectDetail.waitingSubcontractor': '等待分包商',
  'progress.currentStage': '当前阶段',

  // PostUpdateModal
  'postUpdate.title': '发布更新',
  'postUpdate.postAs': '以{role}身份发布',
  'postUpdate.posting': '发布中...',
  'postUpdate.updateType': '更新类型',
  'postUpdate.allParties': '所有方',
  'postUpdate.managementOnly': '仅管理',
  'postUpdate.mgmtAndSub': '管理和分包商',
  'postUpdate.enterTitle': '请输入标题',
  'postUpdate.enterDetails': '请输入详情',
  'postUpdate.titlePlaceholder': '例：厨房家具已安装',
  'postUpdate.details': '详情',
  'postUpdate.detailsPlaceholder': '描述现场进展、问题或备注...',
  'postUpdate.clientHighlight': '客户重点',
  'postUpdate.clientHighlightDesc': '在客户门户中特别展示此更新',
  'postUpdate.currentStage': '当前阶段',
  'postUpdate.justNow': '刚刚',

  // FilesTab feedback
  'files.deleteFileFailed': '删除文件失败',
  'files.fileDeleted': '文件已删除',
  'files.updateVisibilityFailed': '更新可见性失败',
  'files.fileNowVisible': '文件现在可见',
  'files.fileHidden': '文件已隐藏',
  'files.moveFileFailed': '移动文件失败',
  'files.movedToFolder': '已移动到{folder}',
  'files.removedFromFolder': '已从文件夹移除',

  // ScheduleFilterDrawer
  'scheduleFilter.title': '筛选进度计划',
  'scheduleFilter.searchTitle': '搜索标题',
  'scheduleFilter.searchPlaceholder': '搜索进度项...',
  'scheduleFilter.status': '状态',
  'scheduleFilter.stage': '阶段',
  'scheduleFilter.allStages': '所有阶段',
  'scheduleFilter.assignedTo': '分配给',
  'scheduleFilter.all': '全部',
  'scheduleFilter.dateRange': '日期范围',
  'scheduleFilter.allDates': '所有日期',
  'scheduleFilter.thisWeek': '本周',
  'scheduleFilter.thisMonth': '本月',
  'scheduleFilter.customRange': '自定义范围',
  'scheduleFilter.to': '至',
  'scheduleFilter.showExcluded': '显示排除项',
  'scheduleFilter.clearAll': '清除全部',
  'scheduleFilter.applyFilter': '应用筛选',
  'scheduleFilter.statusAll': '全部',
  'scheduleFilter.statusUnfinished': '未完成',
  'scheduleFilter.statusCompleted': '已完成',
  'scheduleFilter.statusDelayed': '延迟',
  'scheduleFilter.statusAtRisk': '风险',

  // ScheduleCompletionBlockModal
  'completionBlock.allApprovalsComplete': '所有批准已完成',
  'completionBlock.manualCompletion': '手动完成',
  'completionBlock.cannotCompleteYet': '暂时无法完成',
  'completionBlock.waitingForApprovals': '等待批准',
  'completionBlock.noChecklist': '此进度项没有关联的清单。',
  'completionBlock.noChecklistMgmtOnly': '此进度项没有关联的清单。只有管理员可以手动标记为完成。',
  'completionBlock.mgmtPlusSub': '{mgmt} 个管理 + {sub} 个分包商检查待处理',
  'completionBlock.subPending': '{sub} 个分包商{check}待处理',
  'completionBlock.mgmtPending': '{mgmt} 个管理{check}待处理',
  'completionBlock.requiredApprovalsIncomplete': '必要的批准未完成',
  'completionBlock.check': '检查',
  'completionBlock.checks': '检查',
  'completionBlock.management': '管理',
  'completionBlock.subcontractor': '分包商',
  'completionBlock.allDone': '全部完成',
  'completionBlock.pending': '待处理',
  'completionBlock.approvalUnits': '{completed} / {total} 批准单元',
  'completionBlock.allApprovalsReady': '所有必要的清单批准已完成。此进度项已准备好标记为完成。',
  'completionBlock.reasonForManual': '手动完成原因',
  'completionBlock.reasonPlaceholder': '例：这是一个没有关联清单项的里程碑标记...',
  'completionBlock.provideReason': '请在手动完成此项目之前提供原因。',
  'completionBlock.cancel': '取消',
  'completionBlock.markComplete': '标为完成',
  'completionBlock.overrideComplete': '覆盖并完成',
  'completionBlock.confirmOverride': '确认覆盖',

  // ScheduleSettingsModal
  'scheduleSettings.title': '进度设置',
  'scheduleSettings.workingDays': '工作日',
  'scheduleSettings.holidays': '假日',
  'scheduleSettings.countryCode': '国家代码',
  'scheduleSettings.countryPlaceholder': '例：NZ',
  'scheduleSettings.region': '地区',
  'scheduleSettings.regionPlaceholder': '例：Auckland',
  'scheduleSettings.save': '保存设置',
  'scheduleSettings.saving': '保存中...',
  'scheduleSettings.cancel': '取消',
  'scheduleSettings.monday': '周一',
  'scheduleSettings.tuesday': '周二',
  'scheduleSettings.wednesday': '周三',
  'scheduleSettings.thursday': '周四',
  'scheduleSettings.friday': '周五',
  'scheduleSettings.saturday': '周六',
  'scheduleSettings.sunday': '周日',

  // ScheduleHistoryDrawer
  'scheduleHistory.title': '变更历史',
  'scheduleHistory.close': '关闭历史面板',
  'scheduleHistory.noHistory': '暂无变更历史',
  'scheduleHistory.loadingHistory': '正在加载历史...',

  // ScheduleItemModalChecklistSection
  'checklistSection.completeMgmtCheck': '完成管理检查',
  'checklistSection.completeSubCheck': '完成分包商检查',

  // EditProject hardcoded strings
  'editProject.projectNotFound': '未找到项目。',
  'editProject.failedToSave': '保存更改失败。',

  // NewProject additional hardcoded strings
  'newProject.scheduleSetupDesc': '选择如何为此项目创建进度计划和清单',
  'newProject.copyDevTemplate': '将156项开发模板复制到此项目',
  'newProject.copyRenovationTemplate': '复制默认翻新进度计划模板',
  'newProject.copyActiveTemplate': '复制此项目类型的活跃模板',
  'newProject.includeDependencyLinksDesc': '从模板复制前驱/后继关系',
  'newProject.generateTimelineDesc': '根据开始日期为所有进度项设置开始日期',
  'newProject.paymentScheduleDesc': '可选 — 设置付款里程碑。可稍后编辑。',
  'newProject.projectNamePreview': '项目名称',
  'newProject.siteAddressPreview': '施工地址',

  // StageProgress
  'stageProgress.sitePlaceholder': '描述现场情况...',
  'stageProgress.stagePhotos': '阶段照片',
  'stageProgress.upload': '上传',
  'stageProgress.stageUpdates': '阶段更新',
  'stageProgress.postUpdate': '发布阶段更新',
  'stageProgress.postUpdateBtn': '发布更新',
  'stageProgress.addPhotos': '添加照片',
  'stageProgress.stageProgress': '阶段进度',
  'stageProgress.photos': '张照片',
  'stageProgress.updates': '条更新',
  'stageProgress.morePhotos': '+{n} 张',
  'stageProgress.subcontractorReport': '分包商报告',
  'stageProgress.managementUpdate': '管理更新',

  // FileRow
  'fileRow.moveToFolder': '移动到文件夹',
  'fileRow.unhide': '取消隐藏',
  'fileRow.hide': '隐藏',
  'fileRow.delete': '删除',
  'fileRow.noFolder': '无文件夹',
  'fileRow.deleteFile': '删除此文件？',
  'fileRow.deleteConfirm': '确定要删除此文件吗？',
  'fileRow.cancel': '取消',
  'fileRow.hidden': '已隐藏',

  // ScheduleChangeLogPanel
  'changeLog.noChanges': '尚未记录任何进度变更。',
  'changeLog.noMatchFilter': '没有符合此筛选条件的变更。',
  'changeLog.filterAll': '全部',
  'changeLog.filterDateChanges': '日期变更',
  'changeLog.filterDelays': '延迟',
  'changeLog.filterClientVisible': '客户可见',
  'changeLog.filterCriticalPath': '关键路径',
  'changeLog.filterCompletion': '完成',
  'changeLog.clientVisible': '客户可见',
  'changeLog.reason': '原因',
  'changeLog.linkedItemsRecalculated': '{n} 个关联项目已重新计算',

  // ScheduleClientView
  'clientView.loadingSchedule': '正在加载进度计划...',
  'clientView.scheduleComingSoon': '进度计划即将公开',
  'clientView.scheduleComingSoonDesc': 'Japan Homes 正在设置项目进度计划。准备就绪后将显示在此处。',
  'clientView.stageProgress': '阶段进度',
  'clientView.constructionMilestones': '施工里程碑',
  'clientView.overallProgress': '整体进度',
  'clientView.stagesCompleted': '{completed}/{total} 个阶段已完成',
  'clientView.expectedCompletion': '预计完成',
  'clientView.currentStage': '当前阶段',
  'clientView.projectComplete': '项目已完成',
  'clientView.nextStage': '下一阶段',
  'clientView.estCompletion': '预计完成日期',
  'clientView.original': '原始日期',
  'clientView.scheduleUpdate': '进度更新',
  'clientView.keyScheduleItems': '关键进度项目',
  'clientView.upcomingWork': '即将开展的工作',
  'clientView.recentlyCompleted': '最近完成',
  'clientView.starts': '开始',
  'clientView.done': '完成',
  'clientView.scheduleLegend': '进度图例',
  'clientView.legendCompleted': '已完成',
  'clientView.legendCurrent': '当前',
  'clientView.legendUpcoming': '即将开展',
  'clientView.scheduleNote': '这是您项目的计划进度。Japan Homes 将就任何变更及时通知您。如有关于日期或进度的问题，请联系 Japan Homes。',
  'clientView.expectedStart': '预计开始',
  'clientView.expectedEnd': '预计结束',
  'clientView.duration': '工期',
  'clientView.workingDays': '个工作日',
  'clientView.progress': '进度',
  'clientView.linkedStages': '关联阶段',
  'clientView.previous': '上一个',
  'clientView.next': '下一个',
  'clientView.update': '更新',
  'clientView.notes': '备注',
  'clientView.close': '关闭',
  'clientView.completed': '已完成',
  'clientView.upcoming': '即将开展',
  'clientView.paymentPercent': '{n}% 付款',

  // ScheduleGanttEditModal
  'ganttEdit.moveItem': '移动进度项目？',
  'ganttEdit.resizeItem': '调整进度项目大小？',
  'ganttEdit.moving': '移动',
  'ganttEdit.shiftingStart': '调整开始日期',
  'ganttEdit.changingDuration': '更改工期',
  'ganttEdit.currentStart': '当前开始日期',
  'ganttEdit.currentEnd': '当前结束日期',
  'ganttEdit.newStart': '新开始日期',
  'ganttEdit.newEnd': '新结束日期',
  'ganttEdit.duration': '工期',
  'ganttEdit.workingDays': '个工作日',
  'ganttEdit.hasSuccessors': '此项目有 {n} 个关联后继项目。',
  'ganttEdit.downstreamAffected': '{n} 个下游项目可能受到影响。',
  'ganttEdit.someComplete': '部分受影响的关联项目已完成。',
  'ganttEdit.recalcDownstream': '重新计算所有下游项目',
  'ganttEdit.itemComplete': '此进度项目已标记为完成。确定要更改其日期吗？',
  'ganttEdit.manualLock': '此项目已手动锁定日期。更改后将保持锁定状态。',
  'ganttEdit.saveAndUpdate': '保存并更新关联项目',
  'ganttEdit.saveOnly': '仅保存此项目',
  'ganttEdit.save': '保存',
  'ganttEdit.cancel': '取消',

  // ScheduleListView hardcoded strings
  'listView.allComplete': '全部 {n} 个项目已完成',
  'listView.notMappedComplete': '{n} 个未映射但已完成',
  'listView.pendingFinal': '最终待处理',
  'listView.noMappingIncomplete': '无映射 + 未完成',
  'listView.incompleteChecklist': '清单未完成',
  'listView.mappedButComplete': '已映射且已完成',
  'listView.notMappedReason': '未映射 — 点击标记完成',
  'listView.pendingFinalReason': '最终待处理 — 点击标记完成',
  'listView.inProgress': '进行中 ({pct}%)',
  'listView.checklistIncomplete': '清单未完成',
  'listView.noChecklistLinked': '此进度项目没有关联的清单。要自动达到100%，请将清单项目映射到此进度项目。或手动标记完成。',
  'listView.linkedChecklistIncomplete': '关联的清单项目未完全批准。请完成所有必要的管理和分包商检查以解锁自动完成。',
  'listView.progressLabel': '进度',
  'listView.checklistItems': '个清单项目',
  'listView.progressDerivedFromChecklist': '进度来自关联清单的完成情况。',
  'listView.noChecklistLinkedManual': '没有关联清单。进度手动设置。',
  'listView.start': '开始',
  'listView.end': '结束',
  'listView.duration': '工期',
  'listView.workingDays': '个工作日',
  'listView.assigned': '分配',
  'listView.checklistCompletion': '清单完成情况',
  'listView.mgmt': '管理',
  'listView.sub': '分包商',
  'listView.mgmtPending': '管理待处理',
  'listView.subPending': '分包商待处理',
  'listView.linkedChecklistItems': '关联清单项目',
  'listView.baselineStart': '基准开始',
  'listView.baselineEnd': '基准结束',
  'listView.criticalPath': '关键路径',
  'listView.criticalPathYes': '是 — 延迟影响完成',
  'listView.delay': '延迟',
  'listView.delayDays': '{n} 天',
  'listView.dependencies': '依赖关系',
  'listView.remove': '删除',
  'listView.editItem': '编辑项目',
  'listView.addLink': '添加链接',
  'listView.sendInstruction': '发送指令',
  'listView.deleteItem': '删除',
  'listView.blockingProgress': '阻塞进度',
  'listView.notMapped': '未映射',
  'listView.manualComplete': '手动完成',
  'listView.noChecklist': '无清单',
  'listView.waitingForSub': '等待分包商',
  'listView.finalComplete': '最终：完成',
  'listView.markComplete': '标记完成',
  'listView.completed': '已完成',
  'listView.incomplete': '未完成',

  // ScheduleGanttView hardcoded strings
  'ganttView.useWeekView': '请使用日视图或周视图进行精确的日期编辑',
  'ganttView.includeAll': '包含所有项目',
  'ganttView.excludeAll': '排除所有项目',
  'ganttView.criticalPath': '关键路径',
  'ganttView.excluded': '已排除',
  'ganttView.final': '最终',
  'ganttView.done': '完成',
  'ganttView.complete': '完成',
  'ganttView.today': '今天',
  'ganttView.excluded2': '已排除',
  'ganttView.noDateAssigned': '未分配日期',
  'ganttView.hiddenLink': '隐藏链接',
  'ganttView.criticalPathNotCalc': '尚未计算关键路径',
  'ganttView.criticalPathDesc': '关键路径识别直接影响项目时间线的任务序列。',
  'ganttView.calculateCriticalPath': '计算关键路径',

  // ScheduleToolbar hardcoded strings
  'toolbar.list': '列表',
  'toolbar.gantt': '甘特图',
  'toolbar.day': '日',
  'toolbar.week': '周',
  'toolbar.month': '月',
  'toolbar.year': '年',
  'toolbar.today': '今天',
  'toolbar.regenerate': '重新生成',
  'toolbar.importPdf': '导入 PDF',
  'toolbar.filter': '筛选',
  'toolbar.filterActive': '筛选已激活',
  'toolbar.phases': '阶段',
  'toolbar.critical': '关键',
  'toolbar.enableCritical': '启用关键路径',
  'toolbar.fullscreen': '全屏',
  'toolbar.exit': '退出',
  'toolbar.more': '更多',
  'toolbar.allStages': '所有阶段',
  'toolbar.allSubStages': '所有子阶段',
  'toolbar.clearStageFilters': '清除阶段筛选器',
  'toolbar.statusAll': '全部',
  'toolbar.statusPending': '最终待处理',
  'toolbar.statusDone': '最终100%',
  'toolbar.statusNoCL': '无清单',
  'toolbar.statusIncCL': '清单未完成',
  'toolbar.statusPendingMobile': '待处理',
  'toolbar.statusDoneMobile': '完成',
  'toolbar.statusNoCLMobile': '无 CL',
  'toolbar.statusIncCLMobile': '未完 CL',
  'toolbar.statusLabel': '状态',
  'toolbar.selected': '已选择',
  'toolbar.selectAll': '选择所有可见项目',
  'toolbar.selectAllMobile': '全部',
  'toolbar.clear': '清除',
  'toolbar.markAllPending': '将所有待处理标记完成',
  'toolbar.markSelected': '标记已选项目',
  'toolbar.markAllPendingMobile': '全部',
  'toolbar.completeMobile': '完成',
  'toolbar.pendingItems': '{n} 个项目待处理',
  'toolbar.scheduleOnline': '在线进度',
  'toolbar.comingSoon': '即将推出',
  'toolbar.exportPdfCsv': '导出为 PDF / CSV',
  'toolbar.scheduleHistory': '进度历史',
  'toolbar.addScheduleItem': '添加进度项目',
  'toolbar.hideAllLinks': '隐藏所有链接',
  'toolbar.showAllLinks': '显示所有链接',
  'toolbar.visibility': '可见性',
  'toolbar.hideExcluded': '隐藏排除项目',
  'toolbar.showExcluded': '显示排除项目',
  'toolbar.includeAll': '包含全部 {n} 个项目',
  'toolbar.excludeAll': '排除所有项目',
  'toolbar.actions': '操作',
  'toolbar.regenerateTimeline': '重新生成时间线',
  'toolbar.createTimeline': '创建时间线',
  'toolbar.importBuildertrend': '导入 Buildertrend PDF',
  'toolbar.recalcProgress': '重新计算进度',
  'toolbar.recalcCriticalPath': '重新计算关键路径',
  'toolbar.recalcLinkedItems': '重新计算关联项目',
  'toolbar.setBaseline': '设置基准线',
  'toolbar.resetCriticalPath': '重置关键路径标志',
  'toolbar.debugInfo': '调试信息',
  'toolbar.hideSummary': '隐藏摘要',
  'toolbar.showSummary': '显示摘要',
  'toolbar.hideLinks': '隐藏链接',
  'toolbar.showLinks': '显示链接',
  'toolbar.hidePhases': '隐藏阶段',
  'toolbar.showPhases': '显示阶段',
  'toolbar.allItems': '所有项目',
  'toolbar.criticalPathOnly': '关键路径',
  'toolbar.hideExcludedMobile': '隐藏排除',
  'toolbar.showExcludedMobile': '显示排除',
  'toolbar.refresh': '刷新',
  'toolbar.addItem': '添加项目',
  'toolbar.clearFilter': '清除',
  'toolbar.marking': '标记中...',
  'toolbar.markAllPendingComplete': '将所有待处理进度项目标记为完成',
  'toolbar.copyGanttColors': '从5 Methuen Road复制甘特颜色',

  // Copy Gantt Colors modal
  'schedule.copyColorsConfirmTitle': '从5 Methuen Road复制甘特颜色？',
  'schedule.copyColorsConfirmDesc': '根据任务编号、标题或排列顺序匹配，将5 Methuen Road的甘特条颜色复制到本项目。仅更改bar_color — 日期、进度和完成状态不受影响。',
  'schedule.copyColorsWarningText': '此项目上的现有自定义条形颜色将被覆盖。',
  'schedule.copyColorsBtn': '复制颜色',
  'schedule.copyingColorsLabel': '复制中...',
  'schedule.dismissResult': '关闭',
  'files.newFileUploaded': '新文件已上传',

  // PaymentsTab notification
  'payments.mgmtConfirmedReceipt': '管理已确认收到您的付款。',

  // PhotosTab notifications
  'photos.newPhotosAdded': '新项目照片已添加到图库。',
  'photos.newPhotosAddedClient': '新项目照片已添加到您的项目图库。',
  'photos.photoNotFound': '未找到照片',
  'photos.deleteFailed': '删除失败',

  // TasksTab notification
  'tasks.clientMarkedPaid': '客户已将此付款标记为已付款。',
  'tasks.mgmtConfirmedReceipt': '管理已确认收到您的付款。',

  // Date locale
  'date.locale': 'zh-CN',
  'date.localeShort': 'zh',

  // Change Orders module
  'nav.changeOrders': '变更单',
  'nav.scheduleTemplates': '进度模板',
  'templates.pageTitle': '进度模板管理',
  'templates.pageDesc': '管理创建新项目时使用的开发和翻新进度模板。',
  'templates.pageDescMulti': '按项目类型管理多个进度模板。更改仅适用于新项目。',
  'templates.createTemplate': '新建模板',
  'templates.create': '创建',
  'templates.filterAll': '全部类型',
  'templates.emptyList': '暂无进度模板。',
  'templates.emptyListHint': '创建模板以为新项目定义进度模式。',
  'templates.emptyFilter': '没有符合此项目类型的模板。',
  'templates.untitledTemplate': '未命名模板',
  'templates.defaultBadge': '默认',
  'templates.draftBadge': '草稿',
  'templates.activeBadge': '有效',
  'templates.itemCount': '{count} 个任务',
  'templates.linkCount': '{count} 个链接',
  'templates.updatedAt': '更新于 {date}',
  'templates.edit': '编辑',
  'templates.duplicate': '复制',
  'templates.exportCsv': '导出 CSV',
  'templates.setDefault': '设为默认',
  'templates.archive': '归档',
  'templates.delete': '删除',
  'templates.importCsv': '导入 CSV',
  'templates.importComingSoon': 'CSV 导入将在后续版本中提供。',
  'templates.duplicatePrompt': '复制模板的名称',
  'templates.duplicated': '模板已复制。',
  'templates.defaultSet': '已更新默认模板。',
  'templates.archiveConfirm': '归档“{name}”？新项目将无法使用。',
  'templates.archived': '模板已归档。',
  'templates.archiveDisabledDefault': '这是默认的{projectType}模板。请先创建另一个{projectType}模板并设为默认后再归档。',
  'templates.archiveDisabledDefaultWithTasks': '这是默认的{projectType}模板。请先设置另一个{projectType}模板为默认后再归档。',
  'templates.archiveDisabledEmptyDefault': '此空模板被标记为默认。请添加任务、设置其他模板为默认，或如未使用则删除。',
  'templates.archiveDisabledOnlyTemplate': '请先创建另一个{projectType}模板并设为默认后再归档此模板。',
  'templates.draftHelp': '草稿模板在包含任务并设为默认之前不会用于新项目。',
  'templates.setDefaultNeedsTasks': '设为默认前请至少添加一个任务。',
  'templates.deleteEmptyConfirm': '删除此空模板？此操作不可撤销。',
  'templates.createdAsDraft': '模板已创建为草稿。设为默认前请添加任务。',
  'templates.savedAsDraft': '已保存为草稿。设为默认前请添加任务。',
  'templates.deleteConfirm': '永久删除“{name}”？此操作不可撤销。',
  'templates.deleted': '模板已删除。',
  'templates.created': '模板已创建。',
  'templates.newTemplateNamePlaceholder': '例如：Development B Pattern',
  'templates.saved': '模板已保存。',
  'templates.saving': '保存中…',
  'templates.searchItems': '搜索任务…',
  'templates.noSearchResults': '没有匹配的任务。',
  'templates.sortOrder': '顺序',
  'newProject.selectScheduleTemplate': '进度模板',
  'newProject.renovationScheduleMode': '翻新进度',
  'newProject.renovationModeLight': '轻量进度（11 个任务）',
  'newProject.renovationModeTemplate': '从模板库选择',
  'newProject.renovationModeBlank': '空白 / 手动',
  'newProject.renovationModeBlankDesc': '不会创建进度任务。创建后请在进度标签页手动添加。',
  'newProject.tasksLabel': '任务',
  'templates.developmentTemplate': '开发模板',
  'templates.developmentTemplateDesc': '基于 Buildertrend 的默认开发进度模板。',
  'templates.renovationTemplate': '翻新模板',
  'templates.renovationTemplateDesc': '默认翻新进度模板。',
  'templates.editorPending': '模板编辑器尚未实现。创建新项目时仍可应用模板。',
  'templates.editorTitleDevelopment': 'Development Schedule Template',
  'templates.editorTitleRenovation': 'Renovation Schedule Template',
  'templates.templateName': '模板名称',
  'templates.templateType': '模板类型',
  'templates.stagesTasksList': '阶段 / 任务',
  'templates.addStageTask': '添加阶段 / 任务',
  'templates.editStageTask': '编辑',
  'templates.deleteStageTask': '删除',
  'templates.applyEdit': '应用',
  'templates.taskTitle': '任务名称',
  'templates.phase': '阶段',
  'templates.durationDays': '工期（天）',
  'templates.days': '天',
  'templates.untitledTask': '未命名任务',
  'templates.noItems': '此模板中尚无阶段或任务。',
  'templates.loading': '正在加载模板…',
  'templates.loadError': '加载模板失败',
  'templates.saveNotConnected': 'Save function is not connected yet',
  'templates.templateLinksHeading': '模板链接 ({count})',
  'templates.addLink': '添加链接',
  'templates.searchLinks': '按任务名称搜索链接…',
  'templates.predecessor': '前置任务',
  'templates.successor': '后续任务',
  'templates.chooseTask': '选择任务…',
  'templates.lagDays': '延迟天数',
  'templates.addDependency': '添加依赖',
  'templates.linksNeedTwoTasks': '创建依赖链接前请先保存至少两个模板任务。',
  'templates.noLinksYet': '尚无模板链接。',
  'templates.noLinkSearchResults': '没有匹配的链接。',
  'templates.linkCountBadge': '{count} 个链接',
  'templates.unknownTask': '未知任务',
  'templates.ganttView': '甘特视图',
  'templates.listView': '列表视图',
  'templates.linkTypeLabel': '类型',
  'templates.lagLabel': '延迟',
  'templates.predecessorLinks': '前置任务',
  'templates.successorLinks': '后续任务',
  'templates.noPredecessorLinks': '此任务没有前置链接。',
  'templates.noSuccessorLinks': '此任务没有后续链接。',
  'templates.ganttSyntheticHint': '根据任务顺序、工期和依赖关系生成的合成时间线（第1天、第2天…）。',
  'templates.ganttSelectTask': '点击任务条以查看和编辑其链接。',
  'templates.ganttSelectedTask': '所选任务',
  'templates.ganttAddSuccessor': '添加后续链接',
  'templates.ganttAddPredecessor': '添加前置链接',
  'templates.ganttLinkCounts': '入/出链接',
  'templates.templateGanttComingSoon': '模板甘特视图即将推出。请暂时使用分组链接编辑器。',
  'co.pageTitle': '变更单',
  'co.pageSubtitle': '跟踪需要客户或分包商确认的范围变更',
  'co.create': '新建变更单',
  'co.items': '条',
  'co.readMore': '阅读更多',
  'co.showLess': '收起',
  'co.clientComment': '客户评论',
  'co.viewInProject': '在项目中查看',
  'co.lockedTooltip': '此变更单已锁定（已批准/已关闭）',
  'co.lockedMessage': '已锁定 — 已批准或关闭的记录无法编辑。如需修改，请新建变更单。',
  'co.status.draft': '草稿',
  'co.status.pendingApproval': '待批准',
  'co.status.sentToClient': '待批准',
  'co.status.approved': '已批准',
  'co.status.clientApproved': '已批准',
  'co.status.rejected': '已拒绝',
  'co.status.clientRejected': '已拒绝',
  'co.status.closed': '已关闭',
  'co.status.inProgress': '进行中',
  'co.status.completed': '已完成',
  'co.status.cancelled': '已取消',
  'co.filter.all': '全部',
  'co.filter.pendingClient': '待批准',
  'co.filter.approved': '已批准',
  'co.filter.rejected': '已拒绝',
  'co.filter.draft': '草稿',
  'co.filter.closed': '已关闭',
  'co.filter.inProgress': '进行中',
  'co.filter.completed': '已完成',
  'co.stats.total': '总计',
  'co.stats.pendingClient': '待批准',
  'co.stats.approved': '已批准',
  'co.stats.draft': '草稿',
  'co.alert.pendingClientApproval': '条变更单待客户确认',
  'co.alert.pendingClientDesc': '客户已收到通知，待确认中。',
  'co.badge.clientApproval': '客户确认',
  'co.badge.clientApproved': '客户已批准',
  'co.badge.clientDeclined': '客户已拒绝',
  'co.clientPortal.visible': '对客户可见',
  'co.clientPortal.autoVisible': '对客户可见',
  'co.clientPortal.hidden': '对客户隐藏',
  'co.clientPortal.draft': '草稿（隐藏）',
  'co.clientPortal.shareWithClient': '分享给客户',
  'co.clientPortal.hideFromClient': '对客户隐藏',
  'co.details.title': '变更单详情',
  'co.details.reason': '原因：',
  'co.details.currentFinish': '当前：',
  'co.details.newFinish': '新：',
  'co.details.costImpact': '费用：',
  'co.details.scheduleImpact': '进度：',
  'co.action.sendToClient': '发送给客户',
  'co.action.markApproved': '标为已批准',
  'co.action.markRejected': '标为已拒绝',
  'co.action.markCompleted': '标为已完成',
  'co.action.close': '关闭',
  'co.action.cancel': '取消',
  'co.action.edit': '编辑变更单',
  'co.action.revertToDraft': '恢复草稿',
  'co.internal.title': '内部信息（客户不可见）',
  'co.internal.builderCost': '施工成本',
  'co.internal.clientPrice': '客户报价',
  'co.internal.margin': '利润',
  'co.clientDesc.label': '客户描述',
  'co.form.createTitle': '新建变更单',
  'co.form.editTitle': '编辑变更单',
  'co.form.titleLabel': '标题',
  'co.form.titlePlaceholder': '例：厨房瓷砖升级',
  'co.form.descriptionLabel': '内部描述',
  'co.form.descriptionPlaceholder': '内部备注（客户不可见）...',
  'co.form.clientDescLabel': '客户描述',
  'co.form.clientDescPlaceholder': '显示给客户的描述...',
  'co.form.reasonLabel': '变更原因',
  'co.form.reasonPlaceholder': '例：客户要求升级',
  'co.form.currentFinishLabel': '当前规格',
  'co.form.currentFinishPlaceholder': '例：标准300×300瓷砖',
  'co.form.newFinishLabel': '新规格',
  'co.form.newFinishPlaceholder': '例：600×600瓷砖',
  'co.form.scheduleImpactLabel': '进度影响',
  'co.form.scheduleImpactPlaceholder': '例：+3个工作日',
  'co.form.builderCostLabel': '施工成本（NZD）',
  'co.form.clientPriceLabel': '客户报价（NZD）',
  'co.form.internalNoteLabel': '内部备注',
  'co.form.internalNotePlaceholder': 'PM专用备注（供应商、利润备注等）...',
  'co.form.statusLabel': '状态',
  'co.form.requiresClientApproval': '需要客户批准',
  'co.form.internalOnly': '仅内部',
  'co.form.clientVisible': '客户可见',
  'co.form.saveChanges': '保存更改',
  'co.form.create': '创建',
  'co.empty.title': '暂无变更单',
  'co.empty.desc': '变更单用于记录范围、规格或费用的变更。',
  'tabs.changeOrders': '变更单',

  // ── Layout additions (Client / Subcontractor) ──
  'nav.myProject': '我的项目',
  'nav.payments': '付款',
  'nav.questions': '问题',
  'role.clientPortal': '客户门户',
  'role.subcontractor': '分包商',
  'user.client': '客户',
  'user.subcontractor': '分包商',

  // ── Relative time (weeks) ──
  'notifications.weekAgo': '{n}周前',
  'notifications.weeksAgo': '{n}周前',

  // ── Notification type translations (title prefix + body) ──
  'notif.type.daily_log_created': '新的每日记录',
  'notif.type.instruction_created': '新的指令',
  'notif.type.change_order_approved': '客户已批准变更单「{title}」',
  'notif.type.schedule_recalculated': '进度已重新计算',
  'notif.type.critical_path_delayed': '关键路径项目已延误: {title}',
  'notif.type.payment_confirmed': '付款已确认',
  'notif.type.photo_uploaded': '新照片已上传',
  'notif.type.file_uploaded': '新文件已上传',
  'notif.type.question_asked': '新问题',
  'notif.type.update_posted': '新更新已发布',
  'notif.type.task_created': '新任务',
  'notif.type.checklist_updated': '清单已更新',

  // ── Notification body translations ──
  'notif.body.schedule_recalculated': '已根据依赖关系变更重新计算相关进度项目。',
  'notif.body.critical_path_delayed': '当前已延误。预计完成日期为 {date}。',
  'notif.body.change_order_approved': '客户已批准变更单。',
  'notif.body.payment_confirmed': '管理已确认收到您的付款。',
  'notif.body.client_marked_paid': '客户已将此付款标记为已付款。',

  // ── Empty states (Part 6) ──
  'checklist.noChecklistItemsEmpty': '没有清单项目',
  'checklist.createDefaultForProject': '为此项目创建默认清单',
  'story.noEventsYet': '暂无故事事件',
  'story.addEvent': '添加事件',
  'schedule.generateInitialTimelineBtn2': '生成初始时间线',
  'schedule.hideDetailsBtn2': '隐藏详情',
  'schedule.showDetailsBtn2': '显示详情',
  'schedule.markAllPendingCompleteBtn': '将所有待处理进度项目标记为完成',
  'schedule.reviewPendingItemsBtn2': '查看待处理项目',
  'schedule.noChecklistMappingLabel': '未关联清单',
  'schedule.pendingScheduleItemsCount': '{count}个进度项目待处理',

  // ScheduleTab status summary
  'schedule.statusHideDetails': '隐藏详情',
  'schedule.statusShowDetails': '显示详情',
  'schedule.notMappedCount': ' · {count}个未映射',

  // ScheduleGenerateModal
  'generateModal.title': '创建 / 重新生成时间线',
  'generateModal.startDateLabel': '项目开始日期',
  'generateModal.nonWorkingDayWarning': '此日期为{day}（非工作日）。第一个项目将自动移至下一个工作日。',
  'generateModal.scopeLabel': '生成时间线的范围',
  'generateModal.scopeAll': '所有活跃进度项目',
  'generateModal.scopeAllDesc': '{count}个包含的项目将获得日期。',
  'generateModal.scopeUnfinished': '仅未完成的活跃项目',
  'generateModal.scopeUnfinishedDesc': '{count}个未完成项目将获得日期。已完成项目保留现有日期。',
  'generateModal.modeLabel': '重新生成模式',
  'generateModal.modeFillEmpty': '仅填充空日期',
  'generateModal.modeFillEmptyDesc': '仅为尚无开始和结束日期的项目分配日期。',
  'generateModal.modeOverwrite': '覆盖所有进度日期',
  'generateModal.modeOverwriteDesc': '替换所有包含进度项目的现有开始和结束日期。',
  'generateModal.modeOverwriteWarning': '将替换包含进度项目的现有开始和结束日期。进度和完成状态不会更改。',
  'generateModal.generating': '生成中...',
  'generateModal.generateBtn': '生成时间线',
  'generateModal.overwriteTitle': '覆盖现有日期？',
  'generateModal.overwriteDesc': '部分进度项目已分配日期。这将替换所有包含项目的现有开始和结束日期。',
  'generateModal.overwriteWarning': '进度和完成状态不会更改。',
  'generateModal.cancel': '取消',
  'generateModal.overwriteGenerate': '覆盖并生成',

  // ScheduleBaselineModal
  'baselineModal.baselineExists': '基准线已存在',
  'baselineModal.setBaseline': '设置基准线',
  'baselineModal.existsDesc': '此项目已存在基准线。您要覆盖基准线日期并创建新快照，还是仅创建新快照？',
  'baselineModal.noBaselineDesc': '将所有进度项目的当前开始和结束日期保存为基准线。这样您可以在以后跟踪进度偏差。',
  'baselineModal.overwriteAndSnapshot': '覆盖基准线并创建快照',
  'baselineModal.snapshotOnly': '仅创建新快照',
  'baselineModal.setBaselineBtn': '设置基准线',
  'baselineModal.cancel': '取消',

  // ScheduleAlertsPanel
  'alertsPanel.alertCount': '{count}个进度提醒',
  'alertsPanel.alertCountPlural': '{count}个进度提醒',
  'alertsPanel.filterAll': '全部',
  'alertsPanel.filterCriticalDelayed': '关键路径延迟',
  'alertsPanel.filterAtRisk': '风险',
  'alertsPanel.filterBehind': '落后',
  'alertsPanel.moreHidden': '{count}个提醒已隐藏',

  // ScheduleSummaryCards
  'summaryCards.projectCompletion': '项目完成',
  'summaryCards.baselineCompletion': '基准线完成',
  'summaryCards.noBaseline': '无基准线',
  'summaryCards.scheduleVariance': '进度偏差',
  'summaryCards.behindDays': '+{n}天落后',
  'summaryCards.aheadDays': '{n}天提前',
  'summaryCards.onBaseline': '按基准线进行',
  'summaryCards.criticalItems': '关键项目',
  'summaryCards.onCriticalPath': '在关键路径上',
  'summaryCards.delayedItems': '延迟项目',
  'summaryCards.behindSchedule': '落后于进度',
  'summaryCards.atRiskItems': '风险项目',
  'summaryCards.dueWithin3Days': '3天内到期',
  'summaryCards.scheduleStatus': '进度状态',
  'summaryCards.scheduleHealth': '进度健康状况',

  // ScheduleSubcontractorView
  'subView.projectSchedule': '项目进度计划',
  'subView.scheduleItemsCount': '{count}个进度项目 · 只读视图',
  'subView.mySchedule': '我的进度',
  'subView.fullProject': '完整项目',
  'subView.cards': '卡片',
  'subView.gantt': '甘特图',
  'subView.stageContext': '阶段状况',
  'subView.noAssigned': '暂无分配给您的项目',
  'subView.noAssignedDesc': '目前没有分配给您公司的进度项目。显示完整项目进度。',
  'subView.readOnly': '只读视图。如需更新进度日期，请联系管理方。',
  'subView.noScheduleYet': '暂无进度计划',
  'subView.noScheduleYetDesc': '项目进度计划尚未设置。请稍后查看。',
  'subView.noItemsToDisplay': '没有可显示的进度项目。',
  'subView.delayedAttention': '延迟 / 需要关注',
  'subView.thisWeek': '本周',
  'subView.nextTwoWeeks': '未来两周',
  'subView.upcomingWork': '即将开展的工作',
  'subView.workingDays': '个工作日',
  'subView.progress': '进度',
  'subView.linkedStages': '关联阶段',
  'subView.notes': '备注',
  'subView.close': '关闭',
  'subView.start': '开始',
  'subView.end': '结束',
  'subView.duration': '工期',
  'subView.delayed': '延迟',
  'subView.atRisk': '风险',
  'subView.onTrack': '正常',
  'subView.comingUp': '即将开始',
  'subView.dueSoon': '即将到期',
  'subView.attentionNeeded': '需要关注',
  'subView.completed': '已完成',

  // ScheduleExportPanel
  'exportPanel.title': '导出进度计划',
  'exportPanel.exportToPDF': '导出为PDF',
  'exportPanel.exportToPDFDesc': '将进度列表打印为PDF',
  'exportPanel.exportToCSV': '导出为CSV',
  'exportPanel.exportToCSVDesc': '将进度下载为电子表格',
  'exportPanel.print': '打印进度计划',
  'exportPanel.printDesc': '打开浏览器打印对话框',
  'exportPanel.note': '甘特图PDF导出功能将在后续改进。目前请使用列表导出。',
  'exportPanel.csvSuccess': 'CSV导出成功',
  'exportPanel.csvFailed': 'CSV导出失败，请重试。',
  'exportPanel.pdfSuccess': 'PDF列表已导出。请使用浏览器打印对话框另存为PDF。',
  'exportPanel.pdfFailed': 'PDF导出失败，请重试。',
  'exportPanel.popupBlocked': '弹出窗口被阻止。请允许弹出窗口后重试。',
  'exportPanel.noPrintableItems': '没有可导出或打印的已包含进度任务。',

  // BuildertrendImportModal
  'btImport.title': '导入 Buildertrend 进度计划',
  'btImport.itemsFromPDF': 'PDF中{count}个项目',
  'btImport.filterAll': '全部',
  'btImport.filterChanges': '仅变更',
  'btImport.filterNew': '新项目',
  'btImport.filterExact': '完全匹配',
  'btImport.filterHigh': '高',
  'btImport.filterMedium': '中',
  'btImport.filterLow': '低',
  'btImport.filterNoMatch': '无匹配',
  'btImport.selectAll': '全选',
  'btImport.deselectAll': '取消全选',
  'btImport.selectedOf': '已选{selected}个 · {withChanges}个有变更',
  'btImport.willBeImported': '{total}个项目中将导入{selected}个',
  'btImport.noMatchFilter': '没有符合此筛选条件的项目。',
  'btImport.back': '返回',
  'btImport.cancel': '取消',
  'btImport.reviewConfirm': '查看并确认',
  'btImport.saving': '保存中…',
  'btImport.confirmImport': '确认导入',
  'btImport.changes': '变更',
  'btImport.matched': '匹配',
  'btImport.newItem': '新项目',
  'btImport.current': '当前',
  'btImport.new': '新',
  'btImport.color': '颜色',
  'btImport.reviewBeforeConfirm': '确认前请先查看',
  'btImport.reviewDesc': '将更新{update}个现有进度项目并创建{create}个新项目。进度和完成状态不会更改。',
  'btImport.itemsToUpdate': '要更新的项目（{count}个）',
  'btImport.newItemsToCreate': '要新建的项目（{count}个）',
  'btImport.columnNo': '#',
  'btImport.columnPDFTitle': 'PDF标题',
  'btImport.columnMatchedItem': '匹配项目',
  'btImport.columnOldStart': '旧开始日期',
  'btImport.columnNewStart': '新开始日期',
  'btImport.columnDuration': '工期',
  'btImport.columnColor': '颜色',
  'btImport.columnTitle': '标题',
  'btImport.columnStart': '开始',
  'btImport.columnEnd': '结束',
  'btImport.columnPhase': '阶段',

  // ScheduleFilterChips
  'filterChips.all': '全部',
  'filterChips.criticalPath': '关键路径',
  'filterChips.delayed': '延迟',
  'filterChips.atRisk': '风险',
  'filterChips.completed': '已完成',
  'filterChips.excluded': '已排除',

  // StagesTab / SubStageCard
  'stagesCard.checksCount': '{checked}/{total}项检查',
  'stagesCard.paymentPercent': '{n}%付款',
  'stagesCard.progressPct': '{pct}%进度',

  // ChecklistTab sub-stage check count
  'checklistSub.checksCount': '{completed}/{total}项检查',
  'checklistSub.paymentPercent': '{n}%付款',

  // Status labels (Part 9)
  'status.open': '未处理',
  'status.overdue': '已逾期',
  'status.upcoming': '即将开始',
  'status.published': '已发布',

  // Mobile-short CTA labels
  'mobile.markAllPendingComplete': '完成所有待处理项',
  'mobile.createDefaultChecklist': '创建默认清单',
  'mobile.reviewPendingItems': '查看待处理项',
  'mobile.generateInitialTimeline': '生成时间线',
  'mobile.sendInstruction': '发送指令',
  'mobile.createChangeOrder': '创建变更单',
  'mobile.assignSubcontractor': '分配分包商',
  'mobile.recalculateProgress': '重新计算',
  'mobile.createScheduleFromTemplate': '创建进度计划',
  'mobile.createDefaultChecklistForProject': '创建清单',
};



export default mgmt;